// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/occto_master_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { BusinessPurpose } from "../../bfftypes/v1/business_purpose_pb";
import { file_bfftypes_v1_business_purpose } from "../../bfftypes/v1/business_purpose_pb";
import type { LicenseType } from "../../bfftypes/v1/license_type_pb";
import { file_bfftypes_v1_license_type } from "../../bfftypes/v1/license_type_pb";
import type { GenerationSaleSubKind } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { BgMaster, BgMasterListItem, BgMemberInput, BgPlantMembershipInput, BusinessMaster, BusinessMasterListItem, DemandProcurementBgInput, DemandProcurementMaster, DemandProcurementMasterListItem, DemandSuppressionMaster, DemandSuppressionMasterListItem, GenerationSalesMaster, GenerationSalesMasterListItem, GenerationSite, GenerationSiteListInfo, GeneratorCategory, NewGenerationSite, PlanMasterBgInput, PlanMasterCodeInput, PlanMasterPlantInput, PlantMaster, PlantMasterListInfo, PlantMasterListItem, PlantMemberInput, PlantUnit, PowerType, SiteAreaMismatch, SubmitterBgMemberInput, SubmitterMaster, SubmitterMasterListItem, SuppressionContractInput, SuppressionPartnerBgInput, TradingPartner, TradingPartnerAccountInput, TradingPartnerContactEntry, TradingPartnerListItem, VoltageClass } from "./occto_master_model_pb";
import { file_bffuser_v1_occto_master_model } from "./occto_master_model_pb";
import type { SplitSupplyBasePatternInput, SplitSupplyBusiness, SplitSupplyContract, SplitSupplyContractListItem, SplitSupplyForm, SplitSupplyNoticeBy, SplitSupplyPointOption } from "./split_supply_contract_model_pb";
import { file_bffuser_v1_split_supply_contract_model } from "./split_supply_contract_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/occto_master_service.proto.
 */
export const file_bffuser_v1_occto_master_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_business_purpose, file_bfftypes_v1_license_type, file_bfftypes_v1_plan_submission, file_bffuser_v1_occto_master_model, file_bffuser_v1_split_supply_contract_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * ListBgMastersRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListBgMastersRequest
 */
export type ListBgMastersRequest = Message<"bffuser.v1.ListBgMastersRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListBgMastersRequest.
 * Use `create(ListBgMastersRequestSchema)` to create a new message.
 */
export const ListBgMastersRequestSchema: GenMessage<ListBgMastersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 0);

/**
 * @generated from message bffuser.v1.ListBgMastersResponse
 */
export type ListBgMastersResponse = Message<"bffuser.v1.ListBgMastersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BgMasterListItem items = 1;
   */
  items: BgMasterListItem[];
};

/**
 * Describes the message bffuser.v1.ListBgMastersResponse.
 * Use `create(ListBgMastersResponseSchema)` to create a new message.
 */
export const ListBgMastersResponseSchema: GenMessage<ListBgMastersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 1);

/**
 * GetBgMasterRequest carries only the id.
 *
 * @generated from message bffuser.v1.GetBgMasterRequest
 */
export type GetBgMasterRequest = Message<"bffuser.v1.GetBgMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetBgMasterRequest.
 * Use `create(GetBgMasterRequestSchema)` to create a new message.
 */
export const GetBgMasterRequestSchema: GenMessage<GetBgMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 2);

/**
 * @generated from message bffuser.v1.GetBgMasterResponse
 */
export type GetBgMasterResponse = Message<"bffuser.v1.GetBgMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.BgMaster bg_master = 1;
   */
  bgMaster?: BgMaster;
};

/**
 * Describes the message bffuser.v1.GetBgMasterResponse.
 * Use `create(GetBgMasterResponseSchema)` to create a new message.
 */
export const GetBgMasterResponseSchema: GenMessage<GetBgMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 3);

/**
 * organization_id and created_by are resolved by the BFF handler from
 * eauth; they are intentionally absent from the frontend-facing request.
 *
 * @generated from message bffuser.v1.CreateBgMasterRequest
 */
export type CreateBgMasterRequest = Message<"bffuser.v1.CreateBgMasterRequest"> & {
  /**
   * OCCTO BG code: business format is validated server-side via
   * valueobject.ParseBgCode (`^[GLD][A-HJ-NP-Z][A-HJ-NP-Z0-9]{2}[0-9]$`,
   * 2 文字目=英字、3〜4 文字目は英数字で I/O を除外); proto only
   * bounds coarse length.
   *
   * @generated from field: string bg_code = 1;
   */
  bgCode: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bfftypes.v1.LicenseType license_type = 3;
   */
  licenseType: LicenseType;

  /**
   * @generated from field: string bg_name = 4;
   */
  bgName: string;

  /**
   * UUID of the representative business master record.
   *
   * @generated from field: string rep_business_master_id = 6;
   */
  repBusinessMasterId: string;

  /**
   * BG members. At least one member is required.
   *
   * @generated from field: repeated bffuser.v1.BgMemberInput members = 7;
   */
  members: BgMemberInput[];

  /**
   * Contract ID number 1. Required for generation BGs; absent otherwise.
   * Presence enforced in usecase based on license_type.
   *
   * @generated from field: optional string contract_id_no_1 = 9;
   */
  contractIdNo1?: string;

  /**
   * Optional free-text note. When present, must not be empty.
   *
   * @generated from field: optional string note = 11;
   */
  note?: string;

  /**
   * 配下発電所リスト. Only accepted on generation BGs; enforced by the
   * backend entity layer, not protovalidate. Capped at 100 entries to
   * bound writes (TradingPartnerAccountInput.weekday_contacts precedent).
   *
   * @generated from field: repeated bffuser.v1.BgPlantMembershipInput plants = 12;
   */
  plants: BgPlantMembershipInput[];

  /**
   * 電源特定コード (WheelingLinkCode). Only accepted on self-wheeling BGs;
   * enforced by the backend entity layer. Coarse length constraint only.
   *
   * @generated from field: optional string wheeling_link_code = 13;
   */
  wheelingLinkCode?: string;

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 14;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 15;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.CreateBgMasterRequest.
 * Use `create(CreateBgMasterRequestSchema)` to create a new message.
 */
export const CreateBgMasterRequestSchema: GenMessage<CreateBgMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 4);

/**
 * @generated from message bffuser.v1.CreateBgMasterResponse
 */
export type CreateBgMasterResponse = Message<"bffuser.v1.CreateBgMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.BgMaster bg_master = 1;
   */
  bgMaster?: BgMaster;
};

/**
 * Describes the message bffuser.v1.CreateBgMasterResponse.
 * Use `create(CreateBgMasterResponseSchema)` to create a new message.
 */
export const CreateBgMasterResponseSchema: GenMessage<CreateBgMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 5);

/**
 * UpdateBgMasterRequest performs a full replacement (PUT semantics).
 * bg_code, area_code, license_type, valid_from, and valid_to are
 * intentionally excluded because they are read-only after creation
 * (AC-006). organization_id and updated_by are resolved by the BFF
 * handler from eauth.
 *
 * @generated from message bffuser.v1.UpdateBgMasterRequest
 */
export type UpdateBgMasterRequest = Message<"bffuser.v1.UpdateBgMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string bg_name = 2;
   */
  bgName: string;

  /**
   * UUID of the representative business master record.
   *
   * @generated from field: string rep_business_master_id = 4;
   */
  repBusinessMasterId: string;

  /**
   * BG members. At least one member is required.
   *
   * @generated from field: repeated bffuser.v1.BgMemberInput members = 5;
   */
  members: BgMemberInput[];

  /**
   * Contract ID number 1. Required for generation BGs; absent otherwise.
   * Presence enforced in usecase based on license_type.
   *
   * @generated from field: optional string contract_id_no_1 = 7;
   */
  contractIdNo1?: string;

  /**
   * Optional free-text note. When present, must not be empty.
   *
   * @generated from field: optional string note = 9;
   */
  note?: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 10;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * 配下発電所リスト (full replacement, same PUT semantics as members).
   * Only accepted on generation BGs; enforced by the backend entity layer.
   * Capped at 100 entries to bound writes (TradingPartnerAccountInput.
   * weekday_contacts precedent).
   *
   * @generated from field: repeated bffuser.v1.BgPlantMembershipInput plants = 11;
   */
  plants: BgPlantMembershipInput[];

  /**
   * 電源特定コード (WheelingLinkCode). Only accepted on self-wheeling BGs;
   * enforced by the backend entity layer. Coarse length constraint only.
   *
   * @generated from field: optional string wheeling_link_code = 12;
   */
  wheelingLinkCode?: string;

  /**
   * Effective-from date (inclusive). Mutable after creation. Required.
   *
   * @generated from field: google.type.Date valid_from = 13;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 14;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.UpdateBgMasterRequest.
 * Use `create(UpdateBgMasterRequestSchema)` to create a new message.
 */
export const UpdateBgMasterRequestSchema: GenMessage<UpdateBgMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 6);

/**
 * @generated from message bffuser.v1.UpdateBgMasterResponse
 */
export type UpdateBgMasterResponse = Message<"bffuser.v1.UpdateBgMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.BgMaster bg_master = 1;
   */
  bgMaster?: BgMaster;
};

/**
 * Describes the message bffuser.v1.UpdateBgMasterResponse.
 * Use `create(UpdateBgMasterResponseSchema)` to create a new message.
 */
export const UpdateBgMasterResponseSchema: GenMessage<UpdateBgMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 7);

/**
 * DeleteBgMasterRequest carries the id and the optimistic-lock baseline.
 * organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.DeleteBgMasterRequest
 */
export type DeleteBgMasterRequest = Message<"bffuser.v1.DeleteBgMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteBgMasterRequest.
 * Use `create(DeleteBgMasterRequestSchema)` to create a new message.
 */
export const DeleteBgMasterRequestSchema: GenMessage<DeleteBgMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 8);

/**
 * DeleteBgMasterResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteBgMasterResponse
 */
export type DeleteBgMasterResponse = Message<"bffuser.v1.DeleteBgMasterResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteBgMasterResponse.
 * Use `create(DeleteBgMasterResponseSchema)` to create a new message.
 */
export const DeleteBgMasterResponseSchema: GenMessage<DeleteBgMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 9);

/**
 * ListBusinessMastersRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListBusinessMastersRequest
 */
export type ListBusinessMastersRequest = Message<"bffuser.v1.ListBusinessMastersRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListBusinessMastersRequest.
 * Use `create(ListBusinessMastersRequestSchema)` to create a new message.
 */
export const ListBusinessMastersRequestSchema: GenMessage<ListBusinessMastersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 10);

/**
 * @generated from message bffuser.v1.ListBusinessMastersResponse
 */
export type ListBusinessMastersResponse = Message<"bffuser.v1.ListBusinessMastersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.BusinessMasterListItem items = 1;
   */
  items: BusinessMasterListItem[];
};

/**
 * Describes the message bffuser.v1.ListBusinessMastersResponse.
 * Use `create(ListBusinessMastersResponseSchema)` to create a new message.
 */
export const ListBusinessMastersResponseSchema: GenMessage<ListBusinessMastersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 11);

/**
 * GetBusinessMasterRequest carries only the id.
 *
 * @generated from message bffuser.v1.GetBusinessMasterRequest
 */
export type GetBusinessMasterRequest = Message<"bffuser.v1.GetBusinessMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetBusinessMasterRequest.
 * Use `create(GetBusinessMasterRequestSchema)` to create a new message.
 */
export const GetBusinessMasterRequestSchema: GenMessage<GetBusinessMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 12);

/**
 * @generated from message bffuser.v1.GetBusinessMasterResponse
 */
export type GetBusinessMasterResponse = Message<"bffuser.v1.GetBusinessMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.BusinessMaster business_master = 1;
   */
  businessMaster?: BusinessMaster;
};

/**
 * Describes the message bffuser.v1.GetBusinessMasterResponse.
 * Use `create(GetBusinessMasterResponseSchema)` to create a new message.
 */
export const GetBusinessMasterResponseSchema: GenMessage<GetBusinessMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 13);

/**
 * organization_id and created_by are resolved by the BFF handler from
 * eauth; they are intentionally absent from the frontend-facing request.
 *
 * @generated from message bffuser.v1.CreateBusinessMasterRequest
 */
export type CreateBusinessMasterRequest = Message<"bffuser.v1.CreateBusinessMasterRequest"> & {
  /**
   * OCCTO 4-character business code. Business format (exactly 4 uppercase
   * alphanumeric characters) is validated server-side via
   * valueobject.ParseBusinessCode; proto only bounds coarse length.
   *
   * @generated from field: string business_code = 1;
   */
  businessCode: string;

  /**
   * Business name. Max 50 characters (spec AC-BZ03); the frontend
   * enforces the same bound, and the backend entity layer re-validates.
   *
   * @generated from field: string business_name = 2;
   */
  businessName: string;

  /**
   * Multi-select license categories. At least one value is required;
   * each element must be a defined non-UNSPECIFIED value.
   *
   * @generated from field: repeated bfftypes.v1.LicenseType license_types = 3;
   */
  licenseTypes: LicenseType[];

  /**
   * Acquisition purpose (取得目的): 通常 / 蓄電池 / 揚水 / 自己託送. Required
   * (UNSPECIFIED rejected); frontend defaults the select to 通常.
   *
   * @generated from field: bfftypes.v1.BusinessPurpose purpose = 4;
   */
  purpose: BusinessPurpose;

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 5;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 6;
   */
  validTo?: Date;

  /**
   * 登録小売電気事業者 登録番号。任意。未設定 (フィールド省略) 時のみ検証を
   * スキップする。明示的な空文字を含む present な値は形式検証 (`^A[0-9]+$`) の
   * 対象で、"" は形式エラーになる (クライアントは未入力時フィールドを省略する)。
   *
   * @generated from field: optional string registration_number = 7;
   */
  registrationNumber?: string;
};

/**
 * Describes the message bffuser.v1.CreateBusinessMasterRequest.
 * Use `create(CreateBusinessMasterRequestSchema)` to create a new message.
 */
export const CreateBusinessMasterRequestSchema: GenMessage<CreateBusinessMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 14);

/**
 * @generated from message bffuser.v1.CreateBusinessMasterResponse
 */
export type CreateBusinessMasterResponse = Message<"bffuser.v1.CreateBusinessMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.BusinessMaster business_master = 1;
   */
  businessMaster?: BusinessMaster;
};

/**
 * Describes the message bffuser.v1.CreateBusinessMasterResponse.
 * Use `create(CreateBusinessMasterResponseSchema)` to create a new message.
 */
export const CreateBusinessMasterResponseSchema: GenMessage<CreateBusinessMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 15);

/**
 * UpdateBusinessMasterRequest performs a full replacement (PUT semantics).
 * business_code is intentionally excluded because it is read-only after
 * creation (AC-006). organization_id and updated_by are resolved by the
 * BFF handler from eauth.
 *
 * @generated from message bffuser.v1.UpdateBusinessMasterRequest
 */
export type UpdateBusinessMasterRequest = Message<"bffuser.v1.UpdateBusinessMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Business name. Max 50 characters (spec AC-BZ03); the frontend
   * enforces the same bound, and the backend entity layer re-validates.
   *
   * @generated from field: string business_name = 2;
   */
  businessName: string;

  /**
   * Multi-select license categories. At least one value is required;
   * each element must be a defined non-UNSPECIFIED value.
   *
   * @generated from field: repeated bfftypes.v1.LicenseType license_types = 3;
   */
  licenseTypes: LicenseType[];

  /**
   * Acquisition purpose (取得目的): 通常 / 蓄電池 / 揚水 / 自己託送. Required
   * (UNSPECIFIED rejected). Independent of license_types (spec AC-04).
   *
   * @generated from field: bfftypes.v1.BusinessPurpose purpose = 4;
   */
  purpose: BusinessPurpose;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 5;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 6;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 7;
   */
  validTo?: Date;

  /**
   * 登録小売電気事業者 登録番号。任意。未設定 (フィールド省略) 時のみ検証を
   * スキップする。明示的な空文字を含む present な値は形式検証 (`^A[0-9]+$`) の
   * 対象で、"" は形式エラーになる (クライアントは未入力時フィールドを省略する)。
   *
   * @generated from field: optional string registration_number = 8;
   */
  registrationNumber?: string;
};

/**
 * Describes the message bffuser.v1.UpdateBusinessMasterRequest.
 * Use `create(UpdateBusinessMasterRequestSchema)` to create a new message.
 */
export const UpdateBusinessMasterRequestSchema: GenMessage<UpdateBusinessMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 16);

/**
 * @generated from message bffuser.v1.UpdateBusinessMasterResponse
 */
export type UpdateBusinessMasterResponse = Message<"bffuser.v1.UpdateBusinessMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.BusinessMaster business_master = 1;
   */
  businessMaster?: BusinessMaster;
};

/**
 * Describes the message bffuser.v1.UpdateBusinessMasterResponse.
 * Use `create(UpdateBusinessMasterResponseSchema)` to create a new message.
 */
export const UpdateBusinessMasterResponseSchema: GenMessage<UpdateBusinessMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 17);

/**
 * DeleteBusinessMasterRequest carries only the id and the optimistic-lock
 * baseline. organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.DeleteBusinessMasterRequest
 */
export type DeleteBusinessMasterRequest = Message<"bffuser.v1.DeleteBusinessMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteBusinessMasterRequest.
 * Use `create(DeleteBusinessMasterRequestSchema)` to create a new message.
 */
export const DeleteBusinessMasterRequestSchema: GenMessage<DeleteBusinessMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 18);

/**
 * DeleteBusinessMasterResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteBusinessMasterResponse
 */
export type DeleteBusinessMasterResponse = Message<"bffuser.v1.DeleteBusinessMasterResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteBusinessMasterResponse.
 * Use `create(DeleteBusinessMasterResponseSchema)` to create a new message.
 */
export const DeleteBusinessMasterResponseSchema: GenMessage<DeleteBusinessMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 19);

/**
 * ListSubmitterMastersRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListSubmitterMastersRequest
 */
export type ListSubmitterMastersRequest = Message<"bffuser.v1.ListSubmitterMastersRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListSubmitterMastersRequest.
 * Use `create(ListSubmitterMastersRequestSchema)` to create a new message.
 */
export const ListSubmitterMastersRequestSchema: GenMessage<ListSubmitterMastersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 20);

/**
 * @generated from message bffuser.v1.ListSubmitterMastersResponse
 */
export type ListSubmitterMastersResponse = Message<"bffuser.v1.ListSubmitterMastersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.SubmitterMasterListItem items = 1;
   */
  items: SubmitterMasterListItem[];
};

/**
 * Describes the message bffuser.v1.ListSubmitterMastersResponse.
 * Use `create(ListSubmitterMastersResponseSchema)` to create a new message.
 */
export const ListSubmitterMastersResponseSchema: GenMessage<ListSubmitterMastersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 21);

/**
 * GetSubmitterMasterRequest carries only the id.
 *
 * @generated from message bffuser.v1.GetSubmitterMasterRequest
 */
export type GetSubmitterMasterRequest = Message<"bffuser.v1.GetSubmitterMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetSubmitterMasterRequest.
 * Use `create(GetSubmitterMasterRequestSchema)` to create a new message.
 */
export const GetSubmitterMasterRequestSchema: GenMessage<GetSubmitterMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 22);

/**
 * @generated from message bffuser.v1.GetSubmitterMasterResponse
 */
export type GetSubmitterMasterResponse = Message<"bffuser.v1.GetSubmitterMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.SubmitterMaster submitter_master = 1;
   */
  submitterMaster?: SubmitterMaster;
};

/**
 * Describes the message bffuser.v1.GetSubmitterMasterResponse.
 * Use `create(GetSubmitterMasterResponseSchema)` to create a new message.
 */
export const GetSubmitterMasterResponseSchema: GenMessage<GetSubmitterMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 23);

/**
 * organization_id and created_by are resolved by the BFF handler from
 * eauth; they are intentionally absent from the frontend-facing request.
 *
 * @generated from message bffuser.v1.CreateSubmitterMasterRequest
 */
export type CreateSubmitterMasterRequest = Message<"bffuser.v1.CreateSubmitterMasterRequest"> & {
  /**
   * OCCTO 5-character submitter code.
   *
   * @generated from field: string submitter_code = 1;
   */
  submitterCode: string;

  /**
   * @generated from field: string submitter_name = 2;
   */
  submitterName: string;

  /**
   * @generated from field: bfftypes.v1.LicenseType license_type = 3;
   */
  licenseType: LicenseType;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * UUID of the linked business master record.
   *
   * @generated from field: string business_master_id = 5;
   */
  businessMasterId: string;

  /**
   * Optional free-text note. When present, must not be empty.
   *
   * @generated from field: optional string note = 6;
   */
  note?: string;

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 7;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 8;
   */
  validTo?: Date;

  /**
   * BG members. 0 items is permitted (submitter may have no BGs initially).
   *
   * @generated from field: repeated bffuser.v1.SubmitterBgMemberInput members = 9;
   */
  members: SubmitterBgMemberInput[];
};

/**
 * Describes the message bffuser.v1.CreateSubmitterMasterRequest.
 * Use `create(CreateSubmitterMasterRequestSchema)` to create a new message.
 */
export const CreateSubmitterMasterRequestSchema: GenMessage<CreateSubmitterMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 24);

/**
 * @generated from message bffuser.v1.CreateSubmitterMasterResponse
 */
export type CreateSubmitterMasterResponse = Message<"bffuser.v1.CreateSubmitterMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.SubmitterMaster submitter_master = 1;
   */
  submitterMaster?: SubmitterMaster;
};

/**
 * Describes the message bffuser.v1.CreateSubmitterMasterResponse.
 * Use `create(CreateSubmitterMasterResponseSchema)` to create a new message.
 */
export const CreateSubmitterMasterResponseSchema: GenMessage<CreateSubmitterMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 25);

/**
 * UpdateSubmitterMasterRequest performs a full replacement (PUT semantics).
 * submitter_code, area_code, and license_type are intentionally excluded
 * because they are read-only after creation (AC-006). organization_id and
 * updated_by are resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.UpdateSubmitterMasterRequest
 */
export type UpdateSubmitterMasterRequest = Message<"bffuser.v1.UpdateSubmitterMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string submitter_name = 2;
   */
  submitterName: string;

  /**
   * UUID of the linked business master record.
   *
   * @generated from field: string business_master_id = 3;
   */
  businessMasterId: string;

  /**
   * Optional free-text note. When present, must not be empty.
   *
   * @generated from field: optional string note = 4;
   */
  note?: string;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 5;
   */
  validTo?: Date;

  /**
   * BG members. 0 items is permitted.
   *
   * @generated from field: repeated bffuser.v1.SubmitterBgMemberInput members = 6;
   */
  members: SubmitterBgMemberInput[];

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 7;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * Effective-from date (inclusive). Mutable after creation. Required.
   *
   * @generated from field: google.type.Date valid_from = 8;
   */
  validFrom?: Date;
};

/**
 * Describes the message bffuser.v1.UpdateSubmitterMasterRequest.
 * Use `create(UpdateSubmitterMasterRequestSchema)` to create a new message.
 */
export const UpdateSubmitterMasterRequestSchema: GenMessage<UpdateSubmitterMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 26);

/**
 * @generated from message bffuser.v1.UpdateSubmitterMasterResponse
 */
export type UpdateSubmitterMasterResponse = Message<"bffuser.v1.UpdateSubmitterMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.SubmitterMaster submitter_master = 1;
   */
  submitterMaster?: SubmitterMaster;
};

/**
 * Describes the message bffuser.v1.UpdateSubmitterMasterResponse.
 * Use `create(UpdateSubmitterMasterResponseSchema)` to create a new message.
 */
export const UpdateSubmitterMasterResponseSchema: GenMessage<UpdateSubmitterMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 27);

/**
 * DeleteSubmitterMasterRequest carries the id and the optimistic-lock
 * baseline. organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.DeleteSubmitterMasterRequest
 */
export type DeleteSubmitterMasterRequest = Message<"bffuser.v1.DeleteSubmitterMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteSubmitterMasterRequest.
 * Use `create(DeleteSubmitterMasterRequestSchema)` to create a new message.
 */
export const DeleteSubmitterMasterRequestSchema: GenMessage<DeleteSubmitterMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 28);

/**
 * DeleteSubmitterMasterResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteSubmitterMasterResponse
 */
export type DeleteSubmitterMasterResponse = Message<"bffuser.v1.DeleteSubmitterMasterResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteSubmitterMasterResponse.
 * Use `create(DeleteSubmitterMasterResponseSchema)` to create a new message.
 */
export const DeleteSubmitterMasterResponseSchema: GenMessage<DeleteSubmitterMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 29);

/**
 * ListTradingPartnersRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListTradingPartnersRequest
 */
export type ListTradingPartnersRequest = Message<"bffuser.v1.ListTradingPartnersRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListTradingPartnersRequest.
 * Use `create(ListTradingPartnersRequestSchema)` to create a new message.
 */
export const ListTradingPartnersRequestSchema: GenMessage<ListTradingPartnersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 30);

/**
 * @generated from message bffuser.v1.ListTradingPartnersResponse
 */
export type ListTradingPartnersResponse = Message<"bffuser.v1.ListTradingPartnersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.TradingPartnerListItem items = 1;
   */
  items: TradingPartnerListItem[];
};

/**
 * Describes the message bffuser.v1.ListTradingPartnersResponse.
 * Use `create(ListTradingPartnersResponseSchema)` to create a new message.
 */
export const ListTradingPartnersResponseSchema: GenMessage<ListTradingPartnersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 31);

/**
 * GetTradingPartnerRequest carries only the id.
 *
 * @generated from message bffuser.v1.GetTradingPartnerRequest
 */
export type GetTradingPartnerRequest = Message<"bffuser.v1.GetTradingPartnerRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetTradingPartnerRequest.
 * Use `create(GetTradingPartnerRequestSchema)` to create a new message.
 */
export const GetTradingPartnerRequestSchema: GenMessage<GetTradingPartnerRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 32);

/**
 * @generated from message bffuser.v1.GetTradingPartnerResponse
 */
export type GetTradingPartnerResponse = Message<"bffuser.v1.GetTradingPartnerResponse"> & {
  /**
   * @generated from field: bffuser.v1.TradingPartner trading_partner = 1;
   */
  tradingPartner?: TradingPartner;
};

/**
 * Describes the message bffuser.v1.GetTradingPartnerResponse.
 * Use `create(GetTradingPartnerResponseSchema)` to create a new message.
 */
export const GetTradingPartnerResponseSchema: GenMessage<GetTradingPartnerResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 33);

/**
 * organization_id and created_by are resolved by the BFF handler from eauth;
 * they are intentionally absent from the frontend-facing request.
 *
 * @generated from message bffuser.v1.CreateTradingPartnerRequest
 */
export type CreateTradingPartnerRequest = Message<"bffuser.v1.CreateTradingPartnerRequest"> & {
  /**
   * TODO(#426): name / short_name の最小桁数制約を再確認する。
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string short_name = 2;
   */
  shortName: string;

  /**
   * Account list. At least one account is required.
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerAccountInput accounts = 3;
   */
  accounts: TradingPartnerAccountInput[];
};

/**
 * Describes the message bffuser.v1.CreateTradingPartnerRequest.
 * Use `create(CreateTradingPartnerRequestSchema)` to create a new message.
 */
export const CreateTradingPartnerRequestSchema: GenMessage<CreateTradingPartnerRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 34);

/**
 * @generated from message bffuser.v1.CreateTradingPartnerResponse
 */
export type CreateTradingPartnerResponse = Message<"bffuser.v1.CreateTradingPartnerResponse"> & {
  /**
   * @generated from field: bffuser.v1.TradingPartner trading_partner = 1;
   */
  tradingPartner?: TradingPartner;
};

/**
 * Describes the message bffuser.v1.CreateTradingPartnerResponse.
 * Use `create(CreateTradingPartnerResponseSchema)` to create a new message.
 */
export const CreateTradingPartnerResponseSchema: GenMessage<CreateTradingPartnerResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 35);

/**
 * UpdateTradingPartnerRequest performs a full replacement (PUT semantics).
 * organization_id and updated_by are resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.UpdateTradingPartnerRequest
 */
export type UpdateTradingPartnerRequest = Message<"bffuser.v1.UpdateTradingPartnerRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * TODO(#426): name / short_name の最小桁数制約を再確認する。
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string short_name = 3;
   */
  shortName: string;

  /**
   * Account list. At least one account is required.
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerAccountInput accounts = 4;
   */
  accounts: TradingPartnerAccountInput[];

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 5;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateTradingPartnerRequest.
 * Use `create(UpdateTradingPartnerRequestSchema)` to create a new message.
 */
export const UpdateTradingPartnerRequestSchema: GenMessage<UpdateTradingPartnerRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 36);

/**
 * @generated from message bffuser.v1.UpdateTradingPartnerResponse
 */
export type UpdateTradingPartnerResponse = Message<"bffuser.v1.UpdateTradingPartnerResponse"> & {
  /**
   * @generated from field: bffuser.v1.TradingPartner trading_partner = 1;
   */
  tradingPartner?: TradingPartner;
};

/**
 * Describes the message bffuser.v1.UpdateTradingPartnerResponse.
 * Use `create(UpdateTradingPartnerResponseSchema)` to create a new message.
 */
export const UpdateTradingPartnerResponseSchema: GenMessage<UpdateTradingPartnerResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 37);

/**
 * DeleteTradingPartnerRequest carries the id and optimistic-lock baseline.
 * organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.DeleteTradingPartnerRequest
 */
export type DeleteTradingPartnerRequest = Message<"bffuser.v1.DeleteTradingPartnerRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteTradingPartnerRequest.
 * Use `create(DeleteTradingPartnerRequestSchema)` to create a new message.
 */
export const DeleteTradingPartnerRequestSchema: GenMessage<DeleteTradingPartnerRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 38);

/**
 * DeleteTradingPartnerResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteTradingPartnerResponse
 */
export type DeleteTradingPartnerResponse = Message<"bffuser.v1.DeleteTradingPartnerResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteTradingPartnerResponse.
 * Use `create(DeleteTradingPartnerResponseSchema)` to create a new message.
 */
export const DeleteTradingPartnerResponseSchema: GenMessage<DeleteTradingPartnerResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 39);

/**
 * GetTradingPartnerContactRequest identifies the trading partner by its
 * OCCTO account code (not a UUID id: the list screen only knows the
 * counterparty code carried on ProcurementPlanRow.counterparties, not the
 * trading_partner_account surrogate id).
 *
 * @generated from message bffuser.v1.GetTradingPartnerContactRequest
 */
export type GetTradingPartnerContactRequest = Message<"bffuser.v1.GetTradingPartnerContactRequest"> & {
  /**
   * @generated from field: string counterparty_code = 1;
   */
  counterpartyCode: string;
};

/**
 * Describes the message bffuser.v1.GetTradingPartnerContactRequest.
 * Use `create(GetTradingPartnerContactRequestSchema)` to create a new message.
 */
export const GetTradingPartnerContactRequestSchema: GenMessage<GetTradingPartnerContactRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 40);

/**
 * @generated from message bffuser.v1.GetTradingPartnerContactResponse
 */
export type GetTradingPartnerContactResponse = Message<"bffuser.v1.GetTradingPartnerContactResponse"> & {
  /**
   * Whether a trading partner account matching counterparty_code was found.
   * False means "not registered in the trading-partner master" (a normal
   * outcome, not an error); weekday_contacts / holiday_contacts are empty
   * and trading_partner_name is absent in that case.
   *
   * @generated from field: bool found = 1;
   */
  found: boolean;

  /**
   * Display name of the owning trading partner. Absent when not found.
   *
   * @generated from field: optional string trading_partner_name = 2;
   */
  tradingPartnerName?: string;

  /**
   * Weekday contact entries (平日昼間連絡先). Empty when none registered.
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerContactEntry weekday_contacts = 3;
   */
  weekdayContacts: TradingPartnerContactEntry[];

  /**
   * Holiday contact entries (休日・夜間連絡先). Empty when none registered.
   *
   * @generated from field: repeated bffuser.v1.TradingPartnerContactEntry holiday_contacts = 4;
   */
  holidayContacts: TradingPartnerContactEntry[];
};

/**
 * Describes the message bffuser.v1.GetTradingPartnerContactResponse.
 * Use `create(GetTradingPartnerContactResponseSchema)` to create a new message.
 */
export const GetTradingPartnerContactResponseSchema: GenMessage<GetTradingPartnerContactResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 41);

/**
 * ListGenerationSalesMastersRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListGenerationSalesMastersRequest
 */
export type ListGenerationSalesMastersRequest = Message<"bffuser.v1.ListGenerationSalesMastersRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListGenerationSalesMastersRequest.
 * Use `create(ListGenerationSalesMastersRequestSchema)` to create a new message.
 */
export const ListGenerationSalesMastersRequestSchema: GenMessage<ListGenerationSalesMastersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 42);

/**
 * @generated from message bffuser.v1.ListGenerationSalesMastersResponse
 */
export type ListGenerationSalesMastersResponse = Message<"bffuser.v1.ListGenerationSalesMastersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.GenerationSalesMasterListItem items = 1;
   */
  items: GenerationSalesMasterListItem[];
};

/**
 * Describes the message bffuser.v1.ListGenerationSalesMastersResponse.
 * Use `create(ListGenerationSalesMastersResponseSchema)` to create a new message.
 */
export const ListGenerationSalesMastersResponseSchema: GenMessage<ListGenerationSalesMastersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 43);

/**
 * GetGenerationSalesMasterRequest carries only the id.
 *
 * @generated from message bffuser.v1.GetGenerationSalesMasterRequest
 */
export type GetGenerationSalesMasterRequest = Message<"bffuser.v1.GetGenerationSalesMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetGenerationSalesMasterRequest.
 * Use `create(GetGenerationSalesMasterRequestSchema)` to create a new message.
 */
export const GetGenerationSalesMasterRequestSchema: GenMessage<GetGenerationSalesMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 44);

/**
 * @generated from message bffuser.v1.GetGenerationSalesMasterResponse
 */
export type GetGenerationSalesMasterResponse = Message<"bffuser.v1.GetGenerationSalesMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.GenerationSalesMaster generation_sales_master = 1;
   */
  generationSalesMaster?: GenerationSalesMaster;
};

/**
 * Describes the message bffuser.v1.GetGenerationSalesMasterResponse.
 * Use `create(GetGenerationSalesMasterResponseSchema)` to create a new message.
 */
export const GetGenerationSalesMasterResponseSchema: GenMessage<GetGenerationSalesMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 45);

/**
 * organization_id and created_by are resolved by the BFF handler from eauth;
 * they are intentionally absent from the frontend-facing request.
 *
 * @generated from message bffuser.v1.CreateGenerationSalesMasterRequest
 */
export type CreateGenerationSalesMasterRequest = Message<"bffuser.v1.CreateGenerationSalesMasterRequest"> & {
  /**
   * UUID of the linked submitter master record.
   *
   * @generated from field: string submitter_master_id = 1;
   */
  submitterMasterId: string;

  /**
   * OCCTO 5-character submitter code (denormalised snapshot).
   *
   * @generated from field: string submitter_code = 2;
   */
  submitterCode: string;

  /**
   * Optional free-text note. When present, must be 1-100 characters
   * (3938-occto-master-plan-spec-followup 設計書 §5、AC-11).
   *
   * @generated from field: optional string note = 3;
   */
  note?: string;

  /**
   * Plan-master code list.
   *
   * @generated from field: repeated bffuser.v1.PlanMasterCodeInput codes = 4;
   */
  codes: PlanMasterCodeInput[];

  /**
   * Plan-master BG list.
   *
   * @generated from field: repeated bffuser.v1.PlanMasterBgInput bgs = 5;
   */
  bgs: PlanMasterBgInput[];

  /**
   * Plan-master plant list.
   *
   * @generated from field: repeated bffuser.v1.PlanMasterPlantInput plants = 6;
   */
  plants: PlanMasterPlantInput[];

  /**
   * 計画区分 (通常電源 / FIT 特例電源). Required; immutable after creation
   * (generation-sales-plan-category 設計書). FIP is invalid for a master
   * (only NORMAL / FIT allowed).
   *
   * @generated from field: bfftypes.v1.GenerationSaleSubKind plan_category = 7;
   */
  planCategory: GenerationSaleSubKind;

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 8;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 9;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.CreateGenerationSalesMasterRequest.
 * Use `create(CreateGenerationSalesMasterRequestSchema)` to create a new message.
 */
export const CreateGenerationSalesMasterRequestSchema: GenMessage<CreateGenerationSalesMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 46);

/**
 * @generated from message bffuser.v1.CreateGenerationSalesMasterResponse
 */
export type CreateGenerationSalesMasterResponse = Message<"bffuser.v1.CreateGenerationSalesMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.GenerationSalesMaster generation_sales_master = 1;
   */
  generationSalesMaster?: GenerationSalesMaster;
};

/**
 * Describes the message bffuser.v1.CreateGenerationSalesMasterResponse.
 * Use `create(CreateGenerationSalesMasterResponseSchema)` to create a new message.
 */
export const CreateGenerationSalesMasterResponseSchema: GenMessage<CreateGenerationSalesMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 47);

/**
 * UpdateGenerationSalesMasterRequest performs a full replacement (PUT semantics).
 * organization_id and updated_by are resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.UpdateGenerationSalesMasterRequest
 */
export type UpdateGenerationSalesMasterRequest = Message<"bffuser.v1.UpdateGenerationSalesMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optional free-text note. When present, must be 1-100 characters
   * (3938-occto-master-plan-spec-followup 設計書 §5、AC-11).
   *
   * @generated from field: optional string note = 2;
   */
  note?: string;

  /**
   * Plan-master code list (full replacement).
   *
   * @generated from field: repeated bffuser.v1.PlanMasterCodeInput codes = 3;
   */
  codes: PlanMasterCodeInput[];

  /**
   * Plan-master BG list (full replacement).
   *
   * @generated from field: repeated bffuser.v1.PlanMasterBgInput bgs = 4;
   */
  bgs: PlanMasterBgInput[];

  /**
   * Plan-master plant list (full replacement).
   *
   * @generated from field: repeated bffuser.v1.PlanMasterPlantInput plants = 5;
   */
  plants: PlanMasterPlantInput[];

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 6;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 7;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 8;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.UpdateGenerationSalesMasterRequest.
 * Use `create(UpdateGenerationSalesMasterRequestSchema)` to create a new message.
 */
export const UpdateGenerationSalesMasterRequestSchema: GenMessage<UpdateGenerationSalesMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 48);

/**
 * @generated from message bffuser.v1.UpdateGenerationSalesMasterResponse
 */
export type UpdateGenerationSalesMasterResponse = Message<"bffuser.v1.UpdateGenerationSalesMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.GenerationSalesMaster generation_sales_master = 1;
   */
  generationSalesMaster?: GenerationSalesMaster;
};

/**
 * Describes the message bffuser.v1.UpdateGenerationSalesMasterResponse.
 * Use `create(UpdateGenerationSalesMasterResponseSchema)` to create a new message.
 */
export const UpdateGenerationSalesMasterResponseSchema: GenMessage<UpdateGenerationSalesMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 49);

/**
 * DeleteGenerationSalesMasterRequest carries the id and optimistic-lock
 * baseline. organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.DeleteGenerationSalesMasterRequest
 */
export type DeleteGenerationSalesMasterRequest = Message<"bffuser.v1.DeleteGenerationSalesMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteGenerationSalesMasterRequest.
 * Use `create(DeleteGenerationSalesMasterRequestSchema)` to create a new message.
 */
export const DeleteGenerationSalesMasterRequestSchema: GenMessage<DeleteGenerationSalesMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 50);

/**
 * DeleteGenerationSalesMasterResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteGenerationSalesMasterResponse
 */
export type DeleteGenerationSalesMasterResponse = Message<"bffuser.v1.DeleteGenerationSalesMasterResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteGenerationSalesMasterResponse.
 * Use `create(DeleteGenerationSalesMasterResponseSchema)` to create a new message.
 */
export const DeleteGenerationSalesMasterResponseSchema: GenMessage<DeleteGenerationSalesMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 51);

/**
 * ListDemandProcurementMastersRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListDemandProcurementMastersRequest
 */
export type ListDemandProcurementMastersRequest = Message<"bffuser.v1.ListDemandProcurementMastersRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListDemandProcurementMastersRequest.
 * Use `create(ListDemandProcurementMastersRequestSchema)` to create a new message.
 */
export const ListDemandProcurementMastersRequestSchema: GenMessage<ListDemandProcurementMastersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 52);

/**
 * @generated from message bffuser.v1.ListDemandProcurementMastersResponse
 */
export type ListDemandProcurementMastersResponse = Message<"bffuser.v1.ListDemandProcurementMastersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.DemandProcurementMasterListItem items = 1;
   */
  items: DemandProcurementMasterListItem[];
};

/**
 * Describes the message bffuser.v1.ListDemandProcurementMastersResponse.
 * Use `create(ListDemandProcurementMastersResponseSchema)` to create a new message.
 */
export const ListDemandProcurementMastersResponseSchema: GenMessage<ListDemandProcurementMastersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 53);

/**
 * GetDemandProcurementMasterRequest carries only the id.
 *
 * @generated from message bffuser.v1.GetDemandProcurementMasterRequest
 */
export type GetDemandProcurementMasterRequest = Message<"bffuser.v1.GetDemandProcurementMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetDemandProcurementMasterRequest.
 * Use `create(GetDemandProcurementMasterRequestSchema)` to create a new message.
 */
export const GetDemandProcurementMasterRequestSchema: GenMessage<GetDemandProcurementMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 54);

/**
 * @generated from message bffuser.v1.GetDemandProcurementMasterResponse
 */
export type GetDemandProcurementMasterResponse = Message<"bffuser.v1.GetDemandProcurementMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.DemandProcurementMaster demand_procurement_master = 1;
   */
  demandProcurementMaster?: DemandProcurementMaster;
};

/**
 * Describes the message bffuser.v1.GetDemandProcurementMasterResponse.
 * Use `create(GetDemandProcurementMasterResponseSchema)` to create a new message.
 */
export const GetDemandProcurementMasterResponseSchema: GenMessage<GetDemandProcurementMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 55);

/**
 * organization_id and created_by are resolved by the BFF handler from eauth;
 * they are intentionally absent from the frontend-facing request.
 *
 * @generated from message bffuser.v1.CreateDemandProcurementMasterRequest
 */
export type CreateDemandProcurementMasterRequest = Message<"bffuser.v1.CreateDemandProcurementMasterRequest"> & {
  /**
   * UUID of the linked BG master record.
   *
   * @generated from field: string bg_master_id = 1;
   */
  bgMasterId: string;

  /**
   * OCCTO 5-character BG code (denormalised snapshot).
   *
   * @generated from field: string bg_code = 2;
   */
  bgCode: string;

  /**
   * Optional free-text note. When present, must be 1-100 characters
   * (3938-occto-master-plan-spec-followup 設計書 §5、AC-11).
   *
   * @generated from field: optional string note = 3;
   */
  note?: string;

  /**
   * Plan-master code list.
   *
   * @generated from field: repeated bffuser.v1.PlanMasterCodeInput codes = 4;
   */
  codes: PlanMasterCodeInput[];

  /**
   * Plan-master BG list. Uses DemandProcurementBgInput (no per-row period).
   *
   * @generated from field: repeated bffuser.v1.DemandProcurementBgInput bgs = 5;
   */
  bgs: DemandProcurementBgInput[];

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 6;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 7;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.CreateDemandProcurementMasterRequest.
 * Use `create(CreateDemandProcurementMasterRequestSchema)` to create a new message.
 */
export const CreateDemandProcurementMasterRequestSchema: GenMessage<CreateDemandProcurementMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 56);

/**
 * @generated from message bffuser.v1.CreateDemandProcurementMasterResponse
 */
export type CreateDemandProcurementMasterResponse = Message<"bffuser.v1.CreateDemandProcurementMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.DemandProcurementMaster demand_procurement_master = 1;
   */
  demandProcurementMaster?: DemandProcurementMaster;
};

/**
 * Describes the message bffuser.v1.CreateDemandProcurementMasterResponse.
 * Use `create(CreateDemandProcurementMasterResponseSchema)` to create a new message.
 */
export const CreateDemandProcurementMasterResponseSchema: GenMessage<CreateDemandProcurementMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 57);

/**
 * UpdateDemandProcurementMasterRequest performs a full replacement (PUT semantics).
 * organization_id and updated_by are resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.UpdateDemandProcurementMasterRequest
 */
export type UpdateDemandProcurementMasterRequest = Message<"bffuser.v1.UpdateDemandProcurementMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optional free-text note. When present, must be 1-100 characters
   * (3938-occto-master-plan-spec-followup 設計書 §5、AC-11).
   *
   * @generated from field: optional string note = 2;
   */
  note?: string;

  /**
   * Plan-master code list (full replacement).
   *
   * @generated from field: repeated bffuser.v1.PlanMasterCodeInput codes = 3;
   */
  codes: PlanMasterCodeInput[];

  /**
   * Plan-master BG list (full replacement). Uses DemandProcurementBgInput
   * (no per-row period).
   *
   * @generated from field: repeated bffuser.v1.DemandProcurementBgInput bgs = 4;
   */
  bgs: DemandProcurementBgInput[];

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 5;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 6;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 7;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.UpdateDemandProcurementMasterRequest.
 * Use `create(UpdateDemandProcurementMasterRequestSchema)` to create a new message.
 */
export const UpdateDemandProcurementMasterRequestSchema: GenMessage<UpdateDemandProcurementMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 58);

/**
 * @generated from message bffuser.v1.UpdateDemandProcurementMasterResponse
 */
export type UpdateDemandProcurementMasterResponse = Message<"bffuser.v1.UpdateDemandProcurementMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.DemandProcurementMaster demand_procurement_master = 1;
   */
  demandProcurementMaster?: DemandProcurementMaster;
};

/**
 * Describes the message bffuser.v1.UpdateDemandProcurementMasterResponse.
 * Use `create(UpdateDemandProcurementMasterResponseSchema)` to create a new message.
 */
export const UpdateDemandProcurementMasterResponseSchema: GenMessage<UpdateDemandProcurementMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 59);

/**
 * DeleteDemandProcurementMasterRequest carries the id and optimistic-lock
 * baseline. organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.DeleteDemandProcurementMasterRequest
 */
export type DeleteDemandProcurementMasterRequest = Message<"bffuser.v1.DeleteDemandProcurementMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteDemandProcurementMasterRequest.
 * Use `create(DeleteDemandProcurementMasterRequestSchema)` to create a new message.
 */
export const DeleteDemandProcurementMasterRequestSchema: GenMessage<DeleteDemandProcurementMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 60);

/**
 * DeleteDemandProcurementMasterResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteDemandProcurementMasterResponse
 */
export type DeleteDemandProcurementMasterResponse = Message<"bffuser.v1.DeleteDemandProcurementMasterResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteDemandProcurementMasterResponse.
 * Use `create(DeleteDemandProcurementMasterResponseSchema)` to create a new message.
 */
export const DeleteDemandProcurementMasterResponseSchema: GenMessage<DeleteDemandProcurementMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 61);

/**
 * ListDemandSuppressionMastersRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListDemandSuppressionMastersRequest
 */
export type ListDemandSuppressionMastersRequest = Message<"bffuser.v1.ListDemandSuppressionMastersRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListDemandSuppressionMastersRequest.
 * Use `create(ListDemandSuppressionMastersRequestSchema)` to create a new message.
 */
export const ListDemandSuppressionMastersRequestSchema: GenMessage<ListDemandSuppressionMastersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 62);

/**
 * @generated from message bffuser.v1.ListDemandSuppressionMastersResponse
 */
export type ListDemandSuppressionMastersResponse = Message<"bffuser.v1.ListDemandSuppressionMastersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.DemandSuppressionMasterListItem items = 1;
   */
  items: DemandSuppressionMasterListItem[];
};

/**
 * Describes the message bffuser.v1.ListDemandSuppressionMastersResponse.
 * Use `create(ListDemandSuppressionMastersResponseSchema)` to create a new message.
 */
export const ListDemandSuppressionMastersResponseSchema: GenMessage<ListDemandSuppressionMastersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 63);

/**
 * GetDemandSuppressionMasterRequest carries only the id.
 *
 * @generated from message bffuser.v1.GetDemandSuppressionMasterRequest
 */
export type GetDemandSuppressionMasterRequest = Message<"bffuser.v1.GetDemandSuppressionMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetDemandSuppressionMasterRequest.
 * Use `create(GetDemandSuppressionMasterRequestSchema)` to create a new message.
 */
export const GetDemandSuppressionMasterRequestSchema: GenMessage<GetDemandSuppressionMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 64);

/**
 * @generated from message bffuser.v1.GetDemandSuppressionMasterResponse
 */
export type GetDemandSuppressionMasterResponse = Message<"bffuser.v1.GetDemandSuppressionMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.DemandSuppressionMaster demand_suppression_master = 1;
   */
  demandSuppressionMaster?: DemandSuppressionMaster;
};

/**
 * Describes the message bffuser.v1.GetDemandSuppressionMasterResponse.
 * Use `create(GetDemandSuppressionMasterResponseSchema)` to create a new message.
 */
export const GetDemandSuppressionMasterResponseSchema: GenMessage<GetDemandSuppressionMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 65);

/**
 * organization_id and created_by are resolved by the BFF handler from eauth;
 * they are intentionally absent from the frontend-facing request.
 *
 * @generated from message bffuser.v1.CreateDemandSuppressionMasterRequest
 */
export type CreateDemandSuppressionMasterRequest = Message<"bffuser.v1.CreateDemandSuppressionMasterRequest"> & {
  /**
   * UUID of the linked submitter master record.
   *
   * @generated from field: string submitter_master_id = 1;
   */
  submitterMasterId: string;

  /**
   * OCCTO 5-character submitter code (denormalised snapshot).
   *
   * @generated from field: string submitter_code = 2;
   */
  submitterCode: string;

  /**
   * Optional free-text note. When present, must not be empty.
   *
   * @generated from field: optional string note = 3;
   */
  note?: string;

  /**
   * Suppression contract list.
   *
   * @generated from field: repeated bffuser.v1.SuppressionContractInput contracts = 4;
   */
  contracts: SuppressionContractInput[];

  /**
   * Suppression partner-BG list.
   *
   * @generated from field: repeated bffuser.v1.SuppressionPartnerBgInput partner_bgs = 5;
   */
  partnerBgs: SuppressionPartnerBgInput[];

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 6;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 7;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.CreateDemandSuppressionMasterRequest.
 * Use `create(CreateDemandSuppressionMasterRequestSchema)` to create a new message.
 */
export const CreateDemandSuppressionMasterRequestSchema: GenMessage<CreateDemandSuppressionMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 66);

/**
 * @generated from message bffuser.v1.CreateDemandSuppressionMasterResponse
 */
export type CreateDemandSuppressionMasterResponse = Message<"bffuser.v1.CreateDemandSuppressionMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.DemandSuppressionMaster demand_suppression_master = 1;
   */
  demandSuppressionMaster?: DemandSuppressionMaster;
};

/**
 * Describes the message bffuser.v1.CreateDemandSuppressionMasterResponse.
 * Use `create(CreateDemandSuppressionMasterResponseSchema)` to create a new message.
 */
export const CreateDemandSuppressionMasterResponseSchema: GenMessage<CreateDemandSuppressionMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 67);

/**
 * UpdateDemandSuppressionMasterRequest performs a full replacement (PUT semantics).
 * organization_id and updated_by are resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.UpdateDemandSuppressionMasterRequest
 */
export type UpdateDemandSuppressionMasterRequest = Message<"bffuser.v1.UpdateDemandSuppressionMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optional free-text note. When present, must not be empty.
   *
   * @generated from field: optional string note = 2;
   */
  note?: string;

  /**
   * Suppression contract list (full replacement).
   *
   * @generated from field: repeated bffuser.v1.SuppressionContractInput contracts = 3;
   */
  contracts: SuppressionContractInput[];

  /**
   * Suppression partner-BG list (full replacement).
   *
   * @generated from field: repeated bffuser.v1.SuppressionPartnerBgInput partner_bgs = 4;
   */
  partnerBgs: SuppressionPartnerBgInput[];

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 5;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * Effective-from date (inclusive). Required.
   *
   * @generated from field: google.type.Date valid_from = 6;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 7;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.UpdateDemandSuppressionMasterRequest.
 * Use `create(UpdateDemandSuppressionMasterRequestSchema)` to create a new message.
 */
export const UpdateDemandSuppressionMasterRequestSchema: GenMessage<UpdateDemandSuppressionMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 68);

/**
 * @generated from message bffuser.v1.UpdateDemandSuppressionMasterResponse
 */
export type UpdateDemandSuppressionMasterResponse = Message<"bffuser.v1.UpdateDemandSuppressionMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.DemandSuppressionMaster demand_suppression_master = 1;
   */
  demandSuppressionMaster?: DemandSuppressionMaster;
};

/**
 * Describes the message bffuser.v1.UpdateDemandSuppressionMasterResponse.
 * Use `create(UpdateDemandSuppressionMasterResponseSchema)` to create a new message.
 */
export const UpdateDemandSuppressionMasterResponseSchema: GenMessage<UpdateDemandSuppressionMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 69);

/**
 * DeleteDemandSuppressionMasterRequest carries the id and optimistic-lock
 * baseline. organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.DeleteDemandSuppressionMasterRequest
 */
export type DeleteDemandSuppressionMasterRequest = Message<"bffuser.v1.DeleteDemandSuppressionMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteDemandSuppressionMasterRequest.
 * Use `create(DeleteDemandSuppressionMasterRequestSchema)` to create a new message.
 */
export const DeleteDemandSuppressionMasterRequestSchema: GenMessage<DeleteDemandSuppressionMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 70);

/**
 * DeleteDemandSuppressionMasterResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteDemandSuppressionMasterResponse
 */
export type DeleteDemandSuppressionMasterResponse = Message<"bffuser.v1.DeleteDemandSuppressionMasterResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteDemandSuppressionMasterResponse.
 * Use `create(DeleteDemandSuppressionMasterResponseSchema)` to create a new message.
 */
export const DeleteDemandSuppressionMasterResponseSchema: GenMessage<DeleteDemandSuppressionMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 71);

/**
 * GetGenerationSalesPlanMasterFormOptionsRequest carries no fields.
 * purpose is fixed by the BFF handler (GENERATION_SALES_BG / GENERATION)
 * and is not exposed to the frontend.
 *
 * @generated from message bffuser.v1.GetGenerationSalesPlanMasterFormOptionsRequest
 */
export type GetGenerationSalesPlanMasterFormOptionsRequest = Message<"bffuser.v1.GetGenerationSalesPlanMasterFormOptionsRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetGenerationSalesPlanMasterFormOptionsRequest.
 * Use `create(GetGenerationSalesPlanMasterFormOptionsRequestSchema)` to create a new message.
 */
export const GetGenerationSalesPlanMasterFormOptionsRequestSchema: GenMessage<GetGenerationSalesPlanMasterFormOptionsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 72);

/**
 * @generated from message bffuser.v1.GetGenerationSalesPlanMasterFormOptionsResponse
 */
export type GetGenerationSalesPlanMasterFormOptionsResponse = Message<"bffuser.v1.GetGenerationSalesPlanMasterFormOptionsResponse"> & {
  /**
   * 計画提出者 candidates filtered to license_type = GENERATION (発電).
   *
   * @generated from field: repeated bffuser.v1.SubmitterMasterListItem submitters = 1;
   */
  submitters: SubmitterMasterListItem[];

  /**
   * 所属BG candidates filtered to license_type = GENERATION (発電).
   * Area narrow is performed client-side after the user selects a submitter.
   *
   * @generated from field: repeated bffuser.v1.BgMasterListItem bgs = 2;
   */
  bgs: BgMasterListItem[];

  /**
   * 発電所 candidates (全件、区分フィルタなし). Area narrow (= 計画提出者と
   * 同一エリア) and already-selected exclusion are performed client-side
   * (gen-sales-plant-master-select 設計書 §4).
   *
   * @generated from field: repeated bffuser.v1.PlantMasterListItem plants = 3;
   */
  plants: PlantMasterListItem[];
};

/**
 * Describes the message bffuser.v1.GetGenerationSalesPlanMasterFormOptionsResponse.
 * Use `create(GetGenerationSalesPlanMasterFormOptionsResponseSchema)` to create a new message.
 */
export const GetGenerationSalesPlanMasterFormOptionsResponseSchema: GenMessage<GetGenerationSalesPlanMasterFormOptionsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 73);

/**
 * GetDemandProcurementPlanMasterFormOptionsRequest carries no fields.
 * purpose is fixed by the BFF handler (DEMAND_PROCUREMENT_BG)
 * and is not exposed to the frontend.
 *
 * @generated from message bffuser.v1.GetDemandProcurementPlanMasterFormOptionsRequest
 */
export type GetDemandProcurementPlanMasterFormOptionsRequest = Message<"bffuser.v1.GetDemandProcurementPlanMasterFormOptionsRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetDemandProcurementPlanMasterFormOptionsRequest.
 * Use `create(GetDemandProcurementPlanMasterFormOptionsRequestSchema)` to create a new message.
 */
export const GetDemandProcurementPlanMasterFormOptionsRequestSchema: GenMessage<GetDemandProcurementPlanMasterFormOptionsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 74);

/**
 * @generated from message bffuser.v1.GetDemandProcurementPlanMasterFormOptionsResponse
 */
export type GetDemandProcurementPlanMasterFormOptionsResponse = Message<"bffuser.v1.GetDemandProcurementPlanMasterFormOptionsResponse"> & {
  /**
   * 代表BG / 所属BG candidates filtered to license_type IN (RETAIL, SELF_WHEELING)
   * (小売/自己託送). Area narrow for 所属BG is performed client-side.
   *
   * @generated from field: repeated bffuser.v1.BgMasterListItem bgs = 1;
   */
  bgs: BgMasterListItem[];
};

/**
 * Describes the message bffuser.v1.GetDemandProcurementPlanMasterFormOptionsResponse.
 * Use `create(GetDemandProcurementPlanMasterFormOptionsResponseSchema)` to create a new message.
 */
export const GetDemandProcurementPlanMasterFormOptionsResponseSchema: GenMessage<GetDemandProcurementPlanMasterFormOptionsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 75);

/**
 * GetDemandSuppressionPlanMasterFormOptionsRequest carries no fields.
 * All purposes are fixed by the BFF handler and are not exposed to the frontend.
 *
 * @generated from message bffuser.v1.GetDemandSuppressionPlanMasterFormOptionsRequest
 */
export type GetDemandSuppressionPlanMasterFormOptionsRequest = Message<"bffuser.v1.GetDemandSuppressionPlanMasterFormOptionsRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetDemandSuppressionPlanMasterFormOptionsRequest.
 * Use `create(GetDemandSuppressionPlanMasterFormOptionsRequestSchema)` to create a new message.
 */
export const GetDemandSuppressionPlanMasterFormOptionsRequestSchema: GenMessage<GetDemandSuppressionPlanMasterFormOptionsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 76);

/**
 * @generated from message bffuser.v1.GetDemandSuppressionPlanMasterFormOptionsResponse
 */
export type GetDemandSuppressionPlanMasterFormOptionsResponse = Message<"bffuser.v1.GetDemandSuppressionPlanMasterFormOptionsResponse"> & {
  /**
   * 計画提出者 candidates filtered to license_type = DR (需要抑制).
   *
   * @generated from field: repeated bffuser.v1.SubmitterMasterListItem submitters = 1;
   */
  submitters: SubmitterMasterListItem[];

  /**
   * 需要抑制BG candidates filtered to license_type = DR (需要抑制).
   * Area narrow is performed client-side.
   *
   * @generated from field: repeated bffuser.v1.BgMasterListItem suppression_bgs = 2;
   */
  suppressionBgs: BgMasterListItem[];

  /**
   * 取引先BG candidates (all license types, no purpose filter).
   * Area narrow is performed client-side.
   *
   * @generated from field: repeated bffuser.v1.BgMasterListItem partner_bgs = 3;
   */
  partnerBgs: BgMasterListItem[];

  /**
   * 事業者 candidates (all, no filter). Mirrors ListBusinessMasters response.
   *
   * @generated from field: repeated bffuser.v1.BusinessMasterListItem businesses = 4;
   */
  businesses: BusinessMasterListItem[];
};

/**
 * Describes the message bffuser.v1.GetDemandSuppressionPlanMasterFormOptionsResponse.
 * Use `create(GetDemandSuppressionPlanMasterFormOptionsResponseSchema)` to create a new message.
 */
export const GetDemandSuppressionPlanMasterFormOptionsResponseSchema: GenMessage<GetDemandSuppressionPlanMasterFormOptionsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 77);

/**
 * ListPlantMastersRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListPlantMastersRequest
 */
export type ListPlantMastersRequest = Message<"bffuser.v1.ListPlantMastersRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListPlantMastersRequest.
 * Use `create(ListPlantMastersRequestSchema)` to create a new message.
 */
export const ListPlantMastersRequestSchema: GenMessage<ListPlantMastersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 78);

/**
 * @generated from message bffuser.v1.ListPlantMastersResponse
 */
export type ListPlantMastersResponse = Message<"bffuser.v1.ListPlantMastersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.PlantMaster items = 1;
   */
  items: PlantMaster[];

  /**
   * The list-only derived data, one per item in the same order.
   *
   * @generated from field: repeated bffuser.v1.PlantMasterListInfo infos = 2;
   */
  infos: PlantMasterListInfo[];
};

/**
 * Describes the message bffuser.v1.ListPlantMastersResponse.
 * Use `create(ListPlantMastersResponseSchema)` to create a new message.
 */
export const ListPlantMastersResponseSchema: GenMessage<ListPlantMastersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 79);

/**
 * GetPlantMasterRequest carries only the id.
 *
 * @generated from message bffuser.v1.GetPlantMasterRequest
 */
export type GetPlantMasterRequest = Message<"bffuser.v1.GetPlantMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetPlantMasterRequest.
 * Use `create(GetPlantMasterRequestSchema)` to create a new message.
 */
export const GetPlantMasterRequestSchema: GenMessage<GetPlantMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 80);

/**
 * @generated from message bffuser.v1.GetPlantMasterResponse
 */
export type GetPlantMasterResponse = Message<"bffuser.v1.GetPlantMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.PlantMaster plant_master = 1;
   */
  plantMaster?: PlantMaster;
};

/**
 * Describes the message bffuser.v1.GetPlantMasterResponse.
 * Use `create(GetPlantMasterResponseSchema)` to create a new message.
 */
export const GetPlantMasterResponseSchema: GenMessage<GetPlantMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 81);

/**
 * organization_id and created_by are resolved by the BFF handler from
 * eauth; they are intentionally absent from the frontend-facing request.
 *
 * @generated from message bffuser.v1.CreatePlantMasterRequest
 */
export type CreatePlantMasterRequest = Message<"bffuser.v1.CreatePlantMasterRequest"> & {
  /**
   * OCCTO plant system code (5 characters). Business format
   * (`[A-Z0-9]{5}`; the code does not encode the area) is validated
   * server-side; proto only bounds coarse length.
   *
   * @generated from field: string plant_code = 1;
   */
  plantCode: string;

  /**
   * @generated from field: string plant_name = 2;
   */
  plantName: string;

  /**
   * @generated from field: string plant_name_abbr = 3;
   */
  plantNameAbbr: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 6;
   */
  voltageClass: VoltageClass;

  /**
   * Maximum receiving power in kW.
   *
   * @generated from field: google.type.Decimal max_receiving_power_kw = 7;
   */
  maxReceivingPowerKw?: Decimal;

  /**
   * UUID of the representative business master record.
   *
   * @generated from field: string business_master_id = 8;
   */
  businessMasterId: string;

  /**
   * Contract ID number 2. Optional free-text. When present, must not be empty.
   *
   * @generated from field: optional string contract_id_no_2 = 9;
   */
  contractIdNo2?: string;

  /**
   * Display priority (1–99). Optional; absent means unset (AC-05).
   *
   * @generated from field: optional int32 priority = 10;
   */
  priority?: number;

  /**
   * Pro-rata internal priority. Optional. Same 1–99 domain as priority;
   * stored as smallint server-side, so the bound also guards against
   * int32→int16 overflow at the persistence boundary.
   *
   * @generated from field: optional int32 pro_rata_priority = 11;
   */
  proRataPriority?: number;

  /**
   * Optional free-text note. When present, must not be empty.
   *
   * @generated from field: optional string note = 12;
   */
  note?: string;

  /**
   * Joint-ownership members. At least one member is required.
   *
   * @generated from field: repeated bffuser.v1.PlantMemberInput members = 13;
   */
  members: PlantMemberInput[];

  /**
   * Effective-from date (inclusive).
   *
   * @generated from field: google.type.Date valid_from = 14;
   */
  validFrom?: Date;

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 15;
   */
  validTo?: Date;
};

/**
 * Describes the message bffuser.v1.CreatePlantMasterRequest.
 * Use `create(CreatePlantMasterRequestSchema)` to create a new message.
 */
export const CreatePlantMasterRequestSchema: GenMessage<CreatePlantMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 82);

/**
 * @generated from message bffuser.v1.CreatePlantMasterResponse
 */
export type CreatePlantMasterResponse = Message<"bffuser.v1.CreatePlantMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.PlantMaster plant_master = 1;
   */
  plantMaster?: PlantMaster;
};

/**
 * Describes the message bffuser.v1.CreatePlantMasterResponse.
 * Use `create(CreatePlantMasterResponseSchema)` to create a new message.
 */
export const CreatePlantMasterResponseSchema: GenMessage<CreatePlantMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 83);

/**
 * UpdatePlantMasterRequest performs a full replacement (PUT semantics).
 * plant_code is read-only after creation (AC-006); the usecase preserves it.
 * area_code is the plant's area itself (not derived from the code) and can be
 * changed, guarded by the usecase: a change is refused when the 系統コード is listed
 * in a 発電販売計画マスタ or a BG of another area than the new one
 * (PLANT_MASTER_ERROR_REASON_AREA_CHANGE_BLOCKED_BY_REGISTRATION), and needs
 * area_change_confirmed = true when units of the 系統コード sit in 発電所 of another
 * area than the new one (PLANT_MASTER_ERROR_REASON_AREA_CHANGE_NEEDS_CONFIRMATION).
 * valid_from is mutable after creation (occto-master-valid-period-6tabs 設計書:
 * 適用開始日は編集可能).
 * organization_id and updated_by are resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.UpdatePlantMasterRequest
 */
export type UpdatePlantMasterRequest = Message<"bffuser.v1.UpdatePlantMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string plant_name = 2;
   */
  plantName: string;

  /**
   * @generated from field: string plant_name_abbr = 3;
   */
  plantNameAbbr: string;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 5;
   */
  voltageClass: VoltageClass;

  /**
   * Maximum receiving power in kW.
   *
   * @generated from field: google.type.Decimal max_receiving_power_kw = 6;
   */
  maxReceivingPowerKw?: Decimal;

  /**
   * UUID of the representative business master record.
   *
   * @generated from field: string business_master_id = 7;
   */
  businessMasterId: string;

  /**
   * Contract ID number 2. Optional free-text. When present, must not be empty.
   *
   * @generated from field: optional string contract_id_no_2 = 8;
   */
  contractIdNo2?: string;

  /**
   * Display priority (1–99). Optional; absent means unset (AC-05b).
   *
   * @generated from field: optional int32 priority = 9;
   */
  priority?: number;

  /**
   * Pro-rata internal priority. Optional.
   *
   * @generated from field: optional int32 pro_rata_priority = 10;
   */
  proRataPriority?: number;

  /**
   * Optional free-text note. When present, must not be empty.
   *
   * @generated from field: optional string note = 11;
   */
  note?: string;

  /**
   * Joint-ownership members. At least one member is required.
   *
   * @generated from field: repeated bffuser.v1.PlantMemberInput members = 12;
   */
  members: PlantMemberInput[];

  /**
   * Effective-to date (inclusive). Absent when open-ended.
   *
   * @generated from field: optional google.type.Date valid_to = 13;
   */
  validTo?: Date;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 14;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * Effective-from date (inclusive). Mutable after creation. Required.
   *
   * @generated from field: google.type.Date valid_from = 15;
   */
  validFrom?: Date;

  /**
   * The plant's area after the update (the source of truth for the area).
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 16;
   */
  areaCode: AreaCode;

  /**
   * true when the user has confirmed the area change after the server asked
   * (PLANT_MASTER_ERROR_REASON_AREA_CHANGE_NEEDS_CONFIRMATION). Ignored when the
   * area does not change.
   *
   * @generated from field: bool area_change_confirmed = 17;
   */
  areaChangeConfirmed: boolean;
};

/**
 * Describes the message bffuser.v1.UpdatePlantMasterRequest.
 * Use `create(UpdatePlantMasterRequestSchema)` to create a new message.
 */
export const UpdatePlantMasterRequestSchema: GenMessage<UpdatePlantMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 84);

/**
 * @generated from message bffuser.v1.UpdatePlantMasterResponse
 */
export type UpdatePlantMasterResponse = Message<"bffuser.v1.UpdatePlantMasterResponse"> & {
  /**
   * @generated from field: bffuser.v1.PlantMaster plant_master = 1;
   */
  plantMaster?: PlantMaster;
};

/**
 * Describes the message bffuser.v1.UpdatePlantMasterResponse.
 * Use `create(UpdatePlantMasterResponseSchema)` to create a new message.
 */
export const UpdatePlantMasterResponseSchema: GenMessage<UpdatePlantMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 85);

/**
 * DeletePlantMasterRequest carries the id and the optimistic-lock baseline.
 * organization_id is resolved by the BFF handler from eauth.
 *
 * @generated from message bffuser.v1.DeletePlantMasterRequest
 */
export type DeletePlantMasterRequest = Message<"bffuser.v1.DeletePlantMasterRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeletePlantMasterRequest.
 * Use `create(DeletePlantMasterRequestSchema)` to create a new message.
 */
export const DeletePlantMasterRequestSchema: GenMessage<DeletePlantMasterRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 86);

/**
 * DeletePlantMasterResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeletePlantMasterResponse
 */
export type DeletePlantMasterResponse = Message<"bffuser.v1.DeletePlantMasterResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeletePlantMasterResponse.
 * Use `create(DeletePlantMasterResponseSchema)` to create a new message.
 */
export const DeletePlantMasterResponseSchema: GenMessage<DeletePlantMasterResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 87);

/**
 * ListGenerationSitesRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListGenerationSitesRequest
 */
export type ListGenerationSitesRequest = Message<"bffuser.v1.ListGenerationSitesRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListGenerationSitesRequest.
 * Use `create(ListGenerationSitesRequestSchema)` to create a new message.
 */
export const ListGenerationSitesRequestSchema: GenMessage<ListGenerationSitesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 88);

/**
 * @generated from message bffuser.v1.ListGenerationSitesResponse
 */
export type ListGenerationSitesResponse = Message<"bffuser.v1.ListGenerationSitesResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.GenerationSite items = 1;
   */
  items: GenerationSite[];

  /**
   * The list-only derived data, one per item in the same order.
   *
   * @generated from field: repeated bffuser.v1.GenerationSiteListInfo infos = 2;
   */
  infos: GenerationSiteListInfo[];
};

/**
 * Describes the message bffuser.v1.ListGenerationSitesResponse.
 * Use `create(ListGenerationSitesResponseSchema)` to create a new message.
 */
export const ListGenerationSitesResponseSchema: GenMessage<ListGenerationSitesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 89);

/**
 * @generated from message bffuser.v1.GetGenerationSiteRequest
 */
export type GetGenerationSiteRequest = Message<"bffuser.v1.GetGenerationSiteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetGenerationSiteRequest.
 * Use `create(GetGenerationSiteRequestSchema)` to create a new message.
 */
export const GetGenerationSiteRequestSchema: GenMessage<GetGenerationSiteRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 90);

/**
 * @generated from message bffuser.v1.GetGenerationSiteResponse
 */
export type GetGenerationSiteResponse = Message<"bffuser.v1.GetGenerationSiteResponse"> & {
  /**
   * @generated from field: bffuser.v1.GenerationSite generation_site = 1;
   */
  generationSite?: GenerationSite;
};

/**
 * Describes the message bffuser.v1.GetGenerationSiteResponse.
 * Use `create(GetGenerationSiteResponseSchema)` to create a new message.
 */
export const GetGenerationSiteResponseSchema: GenMessage<GetGenerationSiteResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 91);

/**
 * The max_len values are coarse upper bounds before trimming; the business
 * limits (name 100 / abbreviation 50 / note 100, counted after trim) are
 * enforced by the backend GenerationSite entity.
 *
 * @generated from message bffuser.v1.CreateGenerationSiteRequest
 */
export type CreateGenerationSiteRequest = Message<"bffuser.v1.CreateGenerationSiteRequest"> & {
  /**
   * @generated from field: string site_name = 1;
   */
  siteName: string;

  /**
   * @generated from field: optional string site_name_abbr = 2;
   */
  siteNameAbbr?: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: optional string note = 4;
   */
  note?: string;
};

/**
 * Describes the message bffuser.v1.CreateGenerationSiteRequest.
 * Use `create(CreateGenerationSiteRequestSchema)` to create a new message.
 */
export const CreateGenerationSiteRequestSchema: GenMessage<CreateGenerationSiteRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 92);

/**
 * @generated from message bffuser.v1.CreateGenerationSiteResponse
 */
export type CreateGenerationSiteResponse = Message<"bffuser.v1.CreateGenerationSiteResponse"> & {
  /**
   * @generated from field: bffuser.v1.GenerationSite generation_site = 1;
   */
  generationSite?: GenerationSite;
};

/**
 * Describes the message bffuser.v1.CreateGenerationSiteResponse.
 * Use `create(CreateGenerationSiteResponseSchema)` to create a new message.
 */
export const CreateGenerationSiteResponseSchema: GenMessage<CreateGenerationSiteResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 93);

/**
 * @generated from message bffuser.v1.UpdateGenerationSiteRequest
 */
export type UpdateGenerationSiteRequest = Message<"bffuser.v1.UpdateGenerationSiteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string site_name = 2;
   */
  siteName: string;

  /**
   * @generated from field: optional string site_name_abbr = 3;
   */
  siteNameAbbr?: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: optional string note = 5;
   */
  note?: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 6;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * true when the user has confirmed the area change after the server asked
   * (GENERATION_SITE_ERROR_REASON_AREA_CHANGE_NEEDS_CONFIRMATION). Ignored when
   * the area does not change.
   *
   * @generated from field: bool area_change_confirmed = 7;
   */
  areaChangeConfirmed: boolean;
};

/**
 * Describes the message bffuser.v1.UpdateGenerationSiteRequest.
 * Use `create(UpdateGenerationSiteRequestSchema)` to create a new message.
 */
export const UpdateGenerationSiteRequestSchema: GenMessage<UpdateGenerationSiteRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 94);

/**
 * @generated from message bffuser.v1.UpdateGenerationSiteResponse
 */
export type UpdateGenerationSiteResponse = Message<"bffuser.v1.UpdateGenerationSiteResponse"> & {
  /**
   * @generated from field: bffuser.v1.GenerationSite generation_site = 1;
   */
  generationSite?: GenerationSite;
};

/**
 * Describes the message bffuser.v1.UpdateGenerationSiteResponse.
 * Use `create(UpdateGenerationSiteResponseSchema)` to create a new message.
 */
export const UpdateGenerationSiteResponseSchema: GenMessage<UpdateGenerationSiteResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 95);

/**
 * @generated from message bffuser.v1.DeleteGenerationSiteRequest
 */
export type DeleteGenerationSiteRequest = Message<"bffuser.v1.DeleteGenerationSiteRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteGenerationSiteRequest.
 * Use `create(DeleteGenerationSiteRequestSchema)` to create a new message.
 */
export const DeleteGenerationSiteRequestSchema: GenMessage<DeleteGenerationSiteRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 96);

/**
 * DeleteGenerationSiteResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteGenerationSiteResponse
 */
export type DeleteGenerationSiteResponse = Message<"bffuser.v1.DeleteGenerationSiteResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteGenerationSiteResponse.
 * Use `create(DeleteGenerationSiteResponseSchema)` to create a new message.
 */
export const DeleteGenerationSiteResponseSchema: GenMessage<DeleteGenerationSiteResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 97);

/**
 * @generated from message bffuser.v1.ListPlantUnitsRequest
 */
export type ListPlantUnitsRequest = Message<"bffuser.v1.ListPlantUnitsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListPlantUnitsRequest.
 * Use `create(ListPlantUnitsRequestSchema)` to create a new message.
 */
export const ListPlantUnitsRequestSchema: GenMessage<ListPlantUnitsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 98);

/**
 * @generated from message bffuser.v1.ListPlantUnitsResponse
 */
export type ListPlantUnitsResponse = Message<"bffuser.v1.ListPlantUnitsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.PlantUnit items = 1;
   */
  items: PlantUnit[];
};

/**
 * Describes the message bffuser.v1.ListPlantUnitsResponse.
 * Use `create(ListPlantUnitsResponseSchema)` to create a new message.
 */
export const ListPlantUnitsResponseSchema: GenMessage<ListPlantUnitsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 99);

/**
 * @generated from message bffuser.v1.GetPlantUnitRequest
 */
export type GetPlantUnitRequest = Message<"bffuser.v1.GetPlantUnitRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message bffuser.v1.GetPlantUnitRequest.
 * Use `create(GetPlantUnitRequestSchema)` to create a new message.
 */
export const GetPlantUnitRequestSchema: GenMessage<GetPlantUnitRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 100);

/**
 * @generated from message bffuser.v1.GetPlantUnitResponse
 */
export type GetPlantUnitResponse = Message<"bffuser.v1.GetPlantUnitResponse"> & {
  /**
   * @generated from field: bffuser.v1.PlantUnit plant_unit = 1;
   */
  plantUnit?: PlantUnit;
};

/**
 * Describes the message bffuser.v1.GetPlantUnitResponse.
 * Use `create(GetPlantUnitResponseSchema)` to create a new message.
 */
export const GetPlantUnitResponseSchema: GenMessage<GetPlantUnitResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 101);

/**
 * CreatePlantUnitRequest registers a 電源ユニット. The 発電所 is either an existing
 * one (generation_site_id) or a new one registered together with the unit
 * (new_site); a new 発電所 is created only when the unit is saved. The max_len
 * values are coarse upper bounds before trimming; the business limits (unit name
 * 100 / abbreviation 50 / note 100, counted after trim) are enforced by the
 * PlantUnit entity.
 *
 * @generated from message bffuser.v1.CreatePlantUnitRequest
 */
export type CreatePlantUnitRequest = Message<"bffuser.v1.CreatePlantUnitRequest"> & {
  /**
   * @generated from oneof bffuser.v1.CreatePlantUnitRequest.site
   */
  site: {
    /**
     * @generated from field: string generation_site_id = 1;
     */
    value: string;
    case: "generationSiteId";
  } | {
    /**
     * @generated from field: bffuser.v1.NewGenerationSite new_site = 2;
     */
    value: NewGenerationSite;
    case: "newSite";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: optional string plant_master_id = 3;
   */
  plantMasterId?: string;

  /**
   * @generated from field: string unit_name = 4;
   */
  unitName: string;

  /**
   * @generated from field: string unit_name_abbr = 5;
   */
  unitNameAbbr: string;

  /**
   * @generated from field: bffuser.v1.GeneratorCategory generator_category = 6;
   */
  generatorCategory: GeneratorCategory;

  /**
   * @generated from field: bffuser.v1.PowerType power_type = 7;
   */
  powerType: PowerType;

  /**
   * @generated from field: int64 authorized_output_kw = 8;
   */
  authorizedOutputKw: bigint;

  /**
   * @generated from field: optional string receiving_point_id = 9;
   */
  receivingPointId?: string;

  /**
   * @generated from field: optional string power_source_id = 10;
   */
  powerSourceId?: string;

  /**
   * @generated from field: optional string generator_identifier = 11;
   */
  generatorIdentifier?: string;

  /**
   * @generated from field: google.type.Date operation_start_date = 12;
   */
  operationStartDate?: Date;

  /**
   * @generated from field: optional google.type.Date operation_end_date = 13;
   */
  operationEndDate?: Date;

  /**
   * @generated from field: google.type.Date valid_from = 14;
   */
  validFrom?: Date;

  /**
   * @generated from field: optional google.type.Date valid_to = 15;
   */
  validTo?: Date;

  /**
   * @generated from field: optional string note = 16;
   */
  note?: string;
};

/**
 * Describes the message bffuser.v1.CreatePlantUnitRequest.
 * Use `create(CreatePlantUnitRequestSchema)` to create a new message.
 */
export const CreatePlantUnitRequestSchema: GenMessage<CreatePlantUnitRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 102);

/**
 * @generated from message bffuser.v1.CreatePlantUnitResponse
 */
export type CreatePlantUnitResponse = Message<"bffuser.v1.CreatePlantUnitResponse"> & {
  /**
   * @generated from field: bffuser.v1.PlantUnit plant_unit = 1;
   */
  plantUnit?: PlantUnit;

  /**
   * Present when the 発電所's area differs from the 系統コード's area (a notice;
   * the unit is saved).
   *
   * @generated from field: optional bffuser.v1.SiteAreaMismatch site_area_mismatch = 2;
   */
  siteAreaMismatch?: SiteAreaMismatch;
};

/**
 * Describes the message bffuser.v1.CreatePlantUnitResponse.
 * Use `create(CreatePlantUnitResponseSchema)` to create a new message.
 */
export const CreatePlantUnitResponseSchema: GenMessage<CreatePlantUnitResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 103);

/**
 * @generated from message bffuser.v1.UpdatePlantUnitRequest
 */
export type UpdatePlantUnitRequest = Message<"bffuser.v1.UpdatePlantUnitRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string generation_site_id = 2;
   */
  generationSiteId: string;

  /**
   * @generated from field: optional string plant_master_id = 3;
   */
  plantMasterId?: string;

  /**
   * @generated from field: string unit_name = 4;
   */
  unitName: string;

  /**
   * @generated from field: string unit_name_abbr = 5;
   */
  unitNameAbbr: string;

  /**
   * @generated from field: bffuser.v1.GeneratorCategory generator_category = 6;
   */
  generatorCategory: GeneratorCategory;

  /**
   * @generated from field: bffuser.v1.PowerType power_type = 7;
   */
  powerType: PowerType;

  /**
   * @generated from field: int64 authorized_output_kw = 8;
   */
  authorizedOutputKw: bigint;

  /**
   * @generated from field: optional string receiving_point_id = 9;
   */
  receivingPointId?: string;

  /**
   * @generated from field: optional string power_source_id = 10;
   */
  powerSourceId?: string;

  /**
   * @generated from field: optional string generator_identifier = 11;
   */
  generatorIdentifier?: string;

  /**
   * @generated from field: google.type.Date operation_start_date = 12;
   */
  operationStartDate?: Date;

  /**
   * @generated from field: optional google.type.Date operation_end_date = 13;
   */
  operationEndDate?: Date;

  /**
   * @generated from field: google.type.Date valid_from = 14;
   */
  validFrom?: Date;

  /**
   * @generated from field: optional google.type.Date valid_to = 15;
   */
  validTo?: Date;

  /**
   * @generated from field: optional string note = 16;
   */
  note?: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 17;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * Q9: the units (id and updated_at) the user confirmed to change together with this one,
   * as listed by the PowerTypeChangeConfirmationDetail of a
   * POWER_TYPE_CHANGE_NEEDS_CONFIRMATION response. Empty on the first request.
   *
   * @generated from field: repeated bffuser.v1.ConfirmedPeerUnit power_type_change_confirmed_units = 18;
   */
  powerTypeChangeConfirmedUnits: ConfirmedPeerUnit[];
};

/**
 * Describes the message bffuser.v1.UpdatePlantUnitRequest.
 * Use `create(UpdatePlantUnitRequestSchema)` to create a new message.
 */
export const UpdatePlantUnitRequestSchema: GenMessage<UpdatePlantUnitRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 104);

/**
 * ConfirmedPeerUnit is a unit the user confirmed to change together with the one being saved.
 *
 * @generated from message bffuser.v1.ConfirmedPeerUnit
 */
export type ConfirmedPeerUnit = Message<"bffuser.v1.ConfirmedPeerUnit"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 2;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.ConfirmedPeerUnit.
 * Use `create(ConfirmedPeerUnitSchema)` to create a new message.
 */
export const ConfirmedPeerUnitSchema: GenMessage<ConfirmedPeerUnit> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 105);

/**
 * @generated from message bffuser.v1.UpdatePlantUnitResponse
 */
export type UpdatePlantUnitResponse = Message<"bffuser.v1.UpdatePlantUnitResponse"> & {
  /**
   * @generated from field: bffuser.v1.PlantUnit plant_unit = 1;
   */
  plantUnit?: PlantUnit;

  /**
   * @generated from field: optional bffuser.v1.SiteAreaMismatch site_area_mismatch = 2;
   */
  siteAreaMismatch?: SiteAreaMismatch;
};

/**
 * Describes the message bffuser.v1.UpdatePlantUnitResponse.
 * Use `create(UpdatePlantUnitResponseSchema)` to create a new message.
 */
export const UpdatePlantUnitResponseSchema: GenMessage<UpdatePlantUnitResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 106);

/**
 * @generated from message bffuser.v1.DeletePlantUnitRequest
 */
export type DeletePlantUnitRequest = Message<"bffuser.v1.DeletePlantUnitRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeletePlantUnitRequest.
 * Use `create(DeletePlantUnitRequestSchema)` to create a new message.
 */
export const DeletePlantUnitRequestSchema: GenMessage<DeletePlantUnitRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 107);

/**
 * DeletePlantUnitResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeletePlantUnitResponse
 */
export type DeletePlantUnitResponse = Message<"bffuser.v1.DeletePlantUnitResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeletePlantUnitResponse.
 * Use `create(DeletePlantUnitResponseSchema)` to create a new message.
 */
export const DeletePlantUnitResponseSchema: GenMessage<DeletePlantUnitResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 108);

/**
 * ListSplitSupplyContractsRequest carries no fields.
 *
 * @generated from message bffuser.v1.ListSplitSupplyContractsRequest
 */
export type ListSplitSupplyContractsRequest = Message<"bffuser.v1.ListSplitSupplyContractsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListSplitSupplyContractsRequest.
 * Use `create(ListSplitSupplyContractsRequestSchema)` to create a new message.
 */
export const ListSplitSupplyContractsRequestSchema: GenMessage<ListSplitSupplyContractsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 109);

/**
 * @generated from message bffuser.v1.ListSplitSupplyContractsResponse
 */
export type ListSplitSupplyContractsResponse = Message<"bffuser.v1.ListSplitSupplyContractsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.SplitSupplyContractListItem items = 1;
   */
  items: SplitSupplyContractListItem[];
};

/**
 * Describes the message bffuser.v1.ListSplitSupplyContractsResponse.
 * Use `create(ListSplitSupplyContractsResponseSchema)` to create a new message.
 */
export const ListSplitSupplyContractsResponseSchema: GenMessage<ListSplitSupplyContractsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 110);

/**
 * GetSplitSupplyContractRequest carries only the identifier.
 *
 * @generated from message bffuser.v1.GetSplitSupplyContractRequest
 */
export type GetSplitSupplyContractRequest = Message<"bffuser.v1.GetSplitSupplyContractRequest"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;
};

/**
 * Describes the message bffuser.v1.GetSplitSupplyContractRequest.
 * Use `create(GetSplitSupplyContractRequestSchema)` to create a new message.
 */
export const GetSplitSupplyContractRequestSchema: GenMessage<GetSplitSupplyContractRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 111);

/**
 * @generated from message bffuser.v1.GetSplitSupplyContractResponse
 */
export type GetSplitSupplyContractResponse = Message<"bffuser.v1.GetSplitSupplyContractResponse"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyContract split_supply_contract = 1;
   */
  splitSupplyContract?: SplitSupplyContract;
};

/**
 * Describes the message bffuser.v1.GetSplitSupplyContractResponse.
 * Use `create(GetSplitSupplyContractResponseSchema)` to create a new message.
 */
export const GetSplitSupplyContractResponseSchema: GenMessage<GetSplitSupplyContractResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 112);

/**
 * organization_id and created_by are resolved by the BFF handler from eauth;
 * they are intentionally absent from the frontend-facing request. Business
 * rules are checked by the backend domain and come back as a
 * SplitSupplyContractErrorReason.
 *
 * @generated from message bffuser.v1.CreateSplitSupplyContractRequest
 */
export type CreateSplitSupplyContractRequest = Message<"bffuser.v1.CreateSplitSupplyContractRequest"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyForm supply_form = 2;
   */
  supplyForm: SplitSupplyForm;

  /**
   * UUID of the 負荷追随分供給者 business master. Empty = not chosen.
   *
   * @generated from field: string load_following_business_master_id = 3;
   */
  loadFollowingBusinessMasterId: string;

  /**
   * @generated from field: optional string load_following_contract_id = 4;
   */
  loadFollowingContractId?: string;

  /**
   * UUID of the ベース分供給者 business master. Empty = not chosen.
   *
   * @generated from field: string base_business_master_id = 5;
   */
  baseBusinessMasterId: string;

  /**
   * @generated from field: optional string base_contract_id = 6;
   */
  baseContractId?: string;

  /**
   * @generated from field: optional int32 base_priority = 7;
   */
  basePriority?: number;

  /**
   * @generated from field: optional int32 own_slot_from = 8;
   */
  ownSlotFrom?: number;

  /**
   * @generated from field: optional int32 own_slot_to = 9;
   */
  ownSlotTo?: number;

  /**
   * @generated from field: string note = 10;
   */
  note: string;

  /**
   * @generated from field: repeated bffuser.v1.SplitSupplyBasePatternInput base_patterns = 11;
   */
  basePatterns: SplitSupplyBasePatternInput[];

  /**
   * 変動型の通告値を出す側。変動型は必須 (UNSPECIFIED = 未選択は NOTICE_BY_REQUIRED で拒否)。他の形態では無視して BASE に正規化
   *
   * @generated from field: bffuser.v1.SplitSupplyNoticeBy notice_by = 12;
   */
  noticeBy: SplitSupplyNoticeBy;

  /**
   * 固定型のベース分供給者の契約電力 (kW)
   *
   * @generated from field: optional google.type.Decimal base_contract_kw = 13;
   */
  baseContractKw?: Decimal;
};

/**
 * Describes the message bffuser.v1.CreateSplitSupplyContractRequest.
 * Use `create(CreateSplitSupplyContractRequestSchema)` to create a new message.
 */
export const CreateSplitSupplyContractRequestSchema: GenMessage<CreateSplitSupplyContractRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 113);

/**
 * @generated from message bffuser.v1.CreateSplitSupplyContractResponse
 */
export type CreateSplitSupplyContractResponse = Message<"bffuser.v1.CreateSplitSupplyContractResponse"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyContract split_supply_contract = 1;
   */
  splitSupplyContract?: SplitSupplyContract;
};

/**
 * Describes the message bffuser.v1.CreateSplitSupplyContractResponse.
 * Use `create(CreateSplitSupplyContractResponseSchema)` to create a new message.
 */
export const CreateSplitSupplyContractResponseSchema: GenMessage<CreateSplitSupplyContractResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 114);

/**
 * organization_id and updated_by are resolved by the BFF handler from eauth.
 * The supply point is the identifier and is not editable.
 *
 * @generated from message bffuser.v1.UpdateSplitSupplyContractRequest
 */
export type UpdateSplitSupplyContractRequest = Message<"bffuser.v1.UpdateSplitSupplyContractRequest"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * @generated from field: bffuser.v1.SplitSupplyForm supply_form = 3;
   */
  supplyForm: SplitSupplyForm;

  /**
   * @generated from field: string load_following_business_master_id = 4;
   */
  loadFollowingBusinessMasterId: string;

  /**
   * @generated from field: optional string load_following_contract_id = 5;
   */
  loadFollowingContractId?: string;

  /**
   * @generated from field: string base_business_master_id = 6;
   */
  baseBusinessMasterId: string;

  /**
   * @generated from field: optional string base_contract_id = 7;
   */
  baseContractId?: string;

  /**
   * @generated from field: optional int32 base_priority = 8;
   */
  basePriority?: number;

  /**
   * @generated from field: optional int32 own_slot_from = 9;
   */
  ownSlotFrom?: number;

  /**
   * @generated from field: optional int32 own_slot_to = 10;
   */
  ownSlotTo?: number;

  /**
   * @generated from field: string note = 11;
   */
  note: string;

  /**
   * Full replacement of the 基本パターン.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyBasePatternInput base_patterns = 12;
   */
  basePatterns: SplitSupplyBasePatternInput[];

  /**
   * 変動型の通告値を出す側。変動型は必須 (UNSPECIFIED = 未選択は NOTICE_BY_REQUIRED で拒否)。他の形態では無視して BASE に正規化
   *
   * @generated from field: bffuser.v1.SplitSupplyNoticeBy notice_by = 13;
   */
  noticeBy: SplitSupplyNoticeBy;

  /**
   * 固定型のベース分供給者の契約電力 (kW)
   *
   * @generated from field: optional google.type.Decimal base_contract_kw = 14;
   */
  baseContractKw?: Decimal;
};

/**
 * Describes the message bffuser.v1.UpdateSplitSupplyContractRequest.
 * Use `create(UpdateSplitSupplyContractRequestSchema)` to create a new message.
 */
export const UpdateSplitSupplyContractRequestSchema: GenMessage<UpdateSplitSupplyContractRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 115);

/**
 * @generated from message bffuser.v1.UpdateSplitSupplyContractResponse
 */
export type UpdateSplitSupplyContractResponse = Message<"bffuser.v1.UpdateSplitSupplyContractResponse"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyContract split_supply_contract = 1;
   */
  splitSupplyContract?: SplitSupplyContract;
};

/**
 * Describes the message bffuser.v1.UpdateSplitSupplyContractResponse.
 * Use `create(UpdateSplitSupplyContractResponseSchema)` to create a new message.
 */
export const UpdateSplitSupplyContractResponseSchema: GenMessage<UpdateSplitSupplyContractResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 116);

/**
 * DeleteSplitSupplyContractRequest carries the identifier and the
 * optimistic-lock baseline.
 *
 * @generated from message bffuser.v1.DeleteSplitSupplyContractRequest
 */
export type DeleteSplitSupplyContractRequest = Message<"bffuser.v1.DeleteSplitSupplyContractRequest"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * Optimistic-lock baseline. Must match the current updated_at of the
   * record; the server returns ABORTED when they differ.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteSplitSupplyContractRequest.
 * Use `create(DeleteSplitSupplyContractRequestSchema)` to create a new message.
 */
export const DeleteSplitSupplyContractRequestSchema: GenMessage<DeleteSplitSupplyContractRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 117);

/**
 * DeleteSplitSupplyContractResponse is intentionally empty (AIP-135).
 *
 * @generated from message bffuser.v1.DeleteSplitSupplyContractResponse
 */
export type DeleteSplitSupplyContractResponse = Message<"bffuser.v1.DeleteSplitSupplyContractResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteSplitSupplyContractResponse.
 * Use `create(DeleteSplitSupplyContractResponseSchema)` to create a new message.
 */
export const DeleteSplitSupplyContractResponseSchema: GenMessage<DeleteSplitSupplyContractResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 118);

/**
 * GetSplitSupplyContractFormOptionsRequest carries no fields.
 *
 * @generated from message bffuser.v1.GetSplitSupplyContractFormOptionsRequest
 */
export type GetSplitSupplyContractFormOptionsRequest = Message<"bffuser.v1.GetSplitSupplyContractFormOptionsRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetSplitSupplyContractFormOptionsRequest.
 * Use `create(GetSplitSupplyContractFormOptionsRequestSchema)` to create a new message.
 */
export const GetSplitSupplyContractFormOptionsRequestSchema: GenMessage<GetSplitSupplyContractFormOptionsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 119);

/**
 * @generated from message bffuser.v1.GetSplitSupplyContractFormOptionsResponse
 */
export type GetSplitSupplyContractFormOptionsResponse = Message<"bffuser.v1.GetSplitSupplyContractFormOptionsResponse"> & {
  /**
   * Supply points a new contract can be made for.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyPointOption supply_points = 1;
   */
  supplyPoints: SplitSupplyPointOption[];

  /**
   * Businesses the own side can be.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyBusiness own_businesses = 2;
   */
  ownBusinesses: SplitSupplyBusiness[];

  /**
   * Businesses the other side can be.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyBusiness partner_businesses = 3;
   */
  partnerBusinesses: SplitSupplyBusiness[];
};

/**
 * Describes the message bffuser.v1.GetSplitSupplyContractFormOptionsResponse.
 * Use `create(GetSplitSupplyContractFormOptionsResponseSchema)` to create a new message.
 */
export const GetSplitSupplyContractFormOptionsResponseSchema: GenMessage<GetSplitSupplyContractFormOptionsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_occto_master_service, 120);

/**
 * OcctoMasterService aggregates Connect RPCs for the "広域マスタ管理"
 * master-data screens (BG master / business master / etc.) consumed by
 * the frontend admin pages.
 *
 * The current organization is derived from the eauth session at the BFF
 * handler layer; client-side filtering for area / license_type is
 * performed in the frontend (matches the contract of backend
 * internalapi.v1.OcctoMasterService).
 *
 * @generated from service bffuser.v1.OcctoMasterService
 */
export const OcctoMasterService: GenService<{
  /**
   * @generated from rpc bffuser.v1.OcctoMasterService.ListBgMasters
   */
  listBgMasters: {
    methodKind: "unary";
    input: typeof ListBgMastersRequestSchema;
    output: typeof ListBgMastersResponseSchema;
  },
  /**
   * GetBgMaster returns the full detail of a single BG master.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetBgMaster
   */
  getBgMaster: {
    methodKind: "unary";
    input: typeof GetBgMasterRequestSchema;
    output: typeof GetBgMasterResponseSchema;
  },
  /**
   * CreateBgMaster creates a new BG master record and returns the full
   * detail of the created record. organization_id and created_by are
   * resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreateBgMaster
   */
  createBgMaster: {
    methodKind: "unary";
    input: typeof CreateBgMasterRequestSchema;
    output: typeof CreateBgMasterResponseSchema;
  },
  /**
   * UpdateBgMaster performs a full replacement (PUT semantics) of the BG
   * master record. bg_code, area_code, license_type, valid_from, and
   * valid_to are immutable after creation (AC-006) and are therefore
   * excluded. Uses optimistic locking via expected_updated_at.
   * organization_id and updated_by are resolved by the BFF handler.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdateBgMaster
   */
  updateBgMaster: {
    methodKind: "unary";
    input: typeof UpdateBgMasterRequestSchema;
    output: typeof UpdateBgMasterResponseSchema;
  },
  /**
   * DeleteBgMaster deletes the BG master record. Uses optimistic locking
   * via expected_updated_at. organization_id is resolved by the BFF handler.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeleteBgMaster
   */
  deleteBgMaster: {
    methodKind: "unary";
    input: typeof DeleteBgMasterRequestSchema;
    output: typeof DeleteBgMasterResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.OcctoMasterService.ListBusinessMasters
   */
  listBusinessMasters: {
    methodKind: "unary";
    input: typeof ListBusinessMastersRequestSchema;
    output: typeof ListBusinessMastersResponseSchema;
  },
  /**
   * GetBusinessMaster returns the full detail of a single business master.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetBusinessMaster
   */
  getBusinessMaster: {
    methodKind: "unary";
    input: typeof GetBusinessMasterRequestSchema;
    output: typeof GetBusinessMasterResponseSchema;
  },
  /**
   * CreateBusinessMaster creates a new business master record and returns
   * the full detail of the created record.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreateBusinessMaster
   */
  createBusinessMaster: {
    methodKind: "unary";
    input: typeof CreateBusinessMasterRequestSchema;
    output: typeof CreateBusinessMasterResponseSchema;
  },
  /**
   * UpdateBusinessMaster performs a full replacement (PUT semantics) of the
   * business master record. business_code is immutable after creation
   * (AC-006) and is therefore excluded. Uses optimistic locking via
   * expected_updated_at.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdateBusinessMaster
   */
  updateBusinessMaster: {
    methodKind: "unary";
    input: typeof UpdateBusinessMasterRequestSchema;
    output: typeof UpdateBusinessMasterResponseSchema;
  },
  /**
   * DeleteBusinessMaster deletes the business master record. Uses optimistic
   * locking via expected_updated_at.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeleteBusinessMaster
   */
  deleteBusinessMaster: {
    methodKind: "unary";
    input: typeof DeleteBusinessMasterRequestSchema;
    output: typeof DeleteBusinessMasterResponseSchema;
  },
  /**
   * ListSubmitterMasters returns the 計画提出者マスタ (submitter master)
   * list-screen projection.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.ListSubmitterMasters
   */
  listSubmitterMasters: {
    methodKind: "unary";
    input: typeof ListSubmitterMastersRequestSchema;
    output: typeof ListSubmitterMastersResponseSchema;
  },
  /**
   * GetSubmitterMaster returns the full detail of a single submitter master.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetSubmitterMaster
   */
  getSubmitterMaster: {
    methodKind: "unary";
    input: typeof GetSubmitterMasterRequestSchema;
    output: typeof GetSubmitterMasterResponseSchema;
  },
  /**
   * CreateSubmitterMaster creates a new submitter master record and returns
   * the full detail of the created record. organization_id and created_by
   * are resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreateSubmitterMaster
   */
  createSubmitterMaster: {
    methodKind: "unary";
    input: typeof CreateSubmitterMasterRequestSchema;
    output: typeof CreateSubmitterMasterResponseSchema;
  },
  /**
   * UpdateSubmitterMaster performs a full replacement (PUT semantics) of the
   * submitter master record. submitter_code, area_code, and license_type are
   * immutable after creation (AC-006) and are therefore excluded.
   * organization_id and updated_by are resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdateSubmitterMaster
   */
  updateSubmitterMaster: {
    methodKind: "unary";
    input: typeof UpdateSubmitterMasterRequestSchema;
    output: typeof UpdateSubmitterMasterResponseSchema;
  },
  /**
   * DeleteSubmitterMaster deletes the submitter master record. Uses optimistic
   * locking via expected_updated_at. organization_id is resolved by the BFF
   * handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeleteSubmitterMaster
   */
  deleteSubmitterMaster: {
    methodKind: "unary";
    input: typeof DeleteSubmitterMasterRequestSchema;
    output: typeof DeleteSubmitterMasterResponseSchema;
  },
  /**
   * ListTradingPartners returns the 取引先マスタ (trading partner master)
   * list-screen projection.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.ListTradingPartners
   */
  listTradingPartners: {
    methodKind: "unary";
    input: typeof ListTradingPartnersRequestSchema;
    output: typeof ListTradingPartnersResponseSchema;
  },
  /**
   * GetTradingPartner returns the full detail of a single trading partner.
   * organization_id is resolved from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetTradingPartner
   */
  getTradingPartner: {
    methodKind: "unary";
    input: typeof GetTradingPartnerRequestSchema;
    output: typeof GetTradingPartnerResponseSchema;
  },
  /**
   * CreateTradingPartner creates a new trading partner record and returns the
   * full detail of the created record. organization_id and created_by are
   * resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreateTradingPartner
   */
  createTradingPartner: {
    methodKind: "unary";
    input: typeof CreateTradingPartnerRequestSchema;
    output: typeof CreateTradingPartnerResponseSchema;
  },
  /**
   * UpdateTradingPartner performs a full replacement (PUT semantics) of the
   * trading partner record. Uses optimistic locking via expected_updated_at.
   * organization_id and updated_by are resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdateTradingPartner
   */
  updateTradingPartner: {
    methodKind: "unary";
    input: typeof UpdateTradingPartnerRequestSchema;
    output: typeof UpdateTradingPartnerResponseSchema;
  },
  /**
   * DeleteTradingPartner deletes the trading partner record. Uses optimistic
   * locking via expected_updated_at. organization_id is resolved from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeleteTradingPartner
   */
  deleteTradingPartner: {
    methodKind: "unary";
    input: typeof DeleteTradingPartnerRequestSchema;
    output: typeof DeleteTradingPartnerResponseSchema;
  },
  /**
   * GetTradingPartnerContact resolves the weekday / holiday contact points
   * of a trading partner identified by its OCCTO account code
   * (counterparty_code), for the 連絡先モーダル lazy-load
   * (plan-common.md §連絡先モーダル AC-CM-001). organization_id is resolved
   * by the BFF handler from eauth. found=false (no error) means the code is
   * not registered in the trading-partner master.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetTradingPartnerContact
   */
  getTradingPartnerContact: {
    methodKind: "unary";
    input: typeof GetTradingPartnerContactRequestSchema;
    output: typeof GetTradingPartnerContactResponseSchema;
  },
  /**
   * ListGenerationSalesMasters returns the 発電販売計画マスタ list-screen
   * projection. organization_id is resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.ListGenerationSalesMasters
   */
  listGenerationSalesMasters: {
    methodKind: "unary";
    input: typeof ListGenerationSalesMastersRequestSchema;
    output: typeof ListGenerationSalesMastersResponseSchema;
  },
  /**
   * GetGenerationSalesMaster returns the full detail of a single
   * generation-sales plan master.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetGenerationSalesMaster
   */
  getGenerationSalesMaster: {
    methodKind: "unary";
    input: typeof GetGenerationSalesMasterRequestSchema;
    output: typeof GetGenerationSalesMasterResponseSchema;
  },
  /**
   * CreateGenerationSalesMaster creates a new generation-sales plan master
   * record. organization_id and created_by are resolved by the BFF handler.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreateGenerationSalesMaster
   */
  createGenerationSalesMaster: {
    methodKind: "unary";
    input: typeof CreateGenerationSalesMasterRequestSchema;
    output: typeof CreateGenerationSalesMasterResponseSchema;
  },
  /**
   * UpdateGenerationSalesMaster performs a full replacement (PUT semantics) of
   * the generation-sales plan master record. Uses optimistic locking via
   * expected_updated_at. organization_id and updated_by are resolved by the
   * BFF handler.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdateGenerationSalesMaster
   */
  updateGenerationSalesMaster: {
    methodKind: "unary";
    input: typeof UpdateGenerationSalesMasterRequestSchema;
    output: typeof UpdateGenerationSalesMasterResponseSchema;
  },
  /**
   * DeleteGenerationSalesMaster deletes the generation-sales plan master record.
   * Uses optimistic locking via expected_updated_at. organization_id is
   * resolved from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeleteGenerationSalesMaster
   */
  deleteGenerationSalesMaster: {
    methodKind: "unary";
    input: typeof DeleteGenerationSalesMasterRequestSchema;
    output: typeof DeleteGenerationSalesMasterResponseSchema;
  },
  /**
   * ListDemandProcurementMasters returns the 需要調達計画マスタ list-screen
   * projection. organization_id is resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.ListDemandProcurementMasters
   */
  listDemandProcurementMasters: {
    methodKind: "unary";
    input: typeof ListDemandProcurementMastersRequestSchema;
    output: typeof ListDemandProcurementMastersResponseSchema;
  },
  /**
   * GetDemandProcurementMaster returns the full detail of a single
   * demand-procurement plan master.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetDemandProcurementMaster
   */
  getDemandProcurementMaster: {
    methodKind: "unary";
    input: typeof GetDemandProcurementMasterRequestSchema;
    output: typeof GetDemandProcurementMasterResponseSchema;
  },
  /**
   * CreateDemandProcurementMaster creates a new demand-procurement plan master
   * record. organization_id and created_by are resolved by the BFF handler.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreateDemandProcurementMaster
   */
  createDemandProcurementMaster: {
    methodKind: "unary";
    input: typeof CreateDemandProcurementMasterRequestSchema;
    output: typeof CreateDemandProcurementMasterResponseSchema;
  },
  /**
   * UpdateDemandProcurementMaster performs a full replacement (PUT semantics)
   * of the demand-procurement plan master record. Uses optimistic locking via
   * expected_updated_at. organization_id and updated_by are resolved by the
   * BFF handler.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdateDemandProcurementMaster
   */
  updateDemandProcurementMaster: {
    methodKind: "unary";
    input: typeof UpdateDemandProcurementMasterRequestSchema;
    output: typeof UpdateDemandProcurementMasterResponseSchema;
  },
  /**
   * DeleteDemandProcurementMaster deletes the demand-procurement plan master
   * record. Uses optimistic locking via expected_updated_at. organization_id
   * is resolved from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeleteDemandProcurementMaster
   */
  deleteDemandProcurementMaster: {
    methodKind: "unary";
    input: typeof DeleteDemandProcurementMasterRequestSchema;
    output: typeof DeleteDemandProcurementMasterResponseSchema;
  },
  /**
   * ListDemandSuppressionMasters returns the 需要抑制計画マスタ list-screen
   * projection. organization_id is resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.ListDemandSuppressionMasters
   */
  listDemandSuppressionMasters: {
    methodKind: "unary";
    input: typeof ListDemandSuppressionMastersRequestSchema;
    output: typeof ListDemandSuppressionMastersResponseSchema;
  },
  /**
   * GetDemandSuppressionMaster returns the full detail of a single
   * demand-suppression plan master.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetDemandSuppressionMaster
   */
  getDemandSuppressionMaster: {
    methodKind: "unary";
    input: typeof GetDemandSuppressionMasterRequestSchema;
    output: typeof GetDemandSuppressionMasterResponseSchema;
  },
  /**
   * CreateDemandSuppressionMaster creates a new demand-suppression plan master
   * record. organization_id and created_by are resolved by the BFF handler.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreateDemandSuppressionMaster
   */
  createDemandSuppressionMaster: {
    methodKind: "unary";
    input: typeof CreateDemandSuppressionMasterRequestSchema;
    output: typeof CreateDemandSuppressionMasterResponseSchema;
  },
  /**
   * UpdateDemandSuppressionMaster performs a full replacement (PUT semantics)
   * of the demand-suppression plan master record. Uses optimistic locking via
   * expected_updated_at. organization_id and updated_by are resolved by the
   * BFF handler.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdateDemandSuppressionMaster
   */
  updateDemandSuppressionMaster: {
    methodKind: "unary";
    input: typeof UpdateDemandSuppressionMasterRequestSchema;
    output: typeof UpdateDemandSuppressionMasterResponseSchema;
  },
  /**
   * DeleteDemandSuppressionMaster deletes the demand-suppression plan master
   * record. Uses optimistic locking via expected_updated_at. organization_id
   * is resolved from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeleteDemandSuppressionMaster
   */
  deleteDemandSuppressionMaster: {
    methodKind: "unary";
    input: typeof DeleteDemandSuppressionMasterRequestSchema;
    output: typeof DeleteDemandSuppressionMasterResponseSchema;
  },
  /**
   * GetGenerationSalesPlanMasterFormOptions returns the form-options DTO for
   * the 発電販売計画マスタ (generation-sales plan master) create/edit modal.
   * The BFF handler fans out to internalapi ListSubmitterMasters(GENERATION),
   * ListBgMasters(GENERATION_SALES_BG), and ListPlantMasters (全件) with a
   * fixed purpose and assembles the result. organization_id is resolved from
   * eauth; purpose is not exposed to the frontend.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetGenerationSalesPlanMasterFormOptions
   */
  getGenerationSalesPlanMasterFormOptions: {
    methodKind: "unary";
    input: typeof GetGenerationSalesPlanMasterFormOptionsRequestSchema;
    output: typeof GetGenerationSalesPlanMasterFormOptionsResponseSchema;
  },
  /**
   * GetDemandProcurementPlanMasterFormOptions returns the form-options DTO for
   * the 需要調達計画マスタ (demand-procurement plan master) create/edit modal.
   * The BFF handler fans out to internalapi ListBgMasters(DEMAND_PROCUREMENT_BG)
   * with a fixed purpose. organization_id is resolved from eauth; purpose is not
   * exposed to the frontend.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetDemandProcurementPlanMasterFormOptions
   */
  getDemandProcurementPlanMasterFormOptions: {
    methodKind: "unary";
    input: typeof GetDemandProcurementPlanMasterFormOptionsRequestSchema;
    output: typeof GetDemandProcurementPlanMasterFormOptionsResponseSchema;
  },
  /**
   * GetDemandSuppressionPlanMasterFormOptions returns the form-options DTO for
   * the 需要抑制計画マスタ (demand-suppression plan master) create/edit modal.
   * The BFF handler fans out to internalapi ListSubmitterMasters(DEMAND_SUPPRESSION),
   * ListBgMasters(DEMAND_SUPPRESSION_BG), ListBgMasters(purpose absent = all),
   * and ListBusinessMasters with fixed purposes. organization_id is resolved
   * from eauth; purpose is not exposed to the frontend.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetDemandSuppressionPlanMasterFormOptions
   */
  getDemandSuppressionPlanMasterFormOptions: {
    methodKind: "unary";
    input: typeof GetDemandSuppressionPlanMasterFormOptionsRequestSchema;
    output: typeof GetDemandSuppressionPlanMasterFormOptionsResponseSchema;
  },
  /**
   * ListPlantMasters returns the 発電所マスタ (plant master) list.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.ListPlantMasters
   */
  listPlantMasters: {
    methodKind: "unary";
    input: typeof ListPlantMastersRequestSchema;
    output: typeof ListPlantMastersResponseSchema;
  },
  /**
   * GetPlantMaster returns the full detail of a single plant master.
   * organization_id is resolved from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetPlantMaster
   */
  getPlantMaster: {
    methodKind: "unary";
    input: typeof GetPlantMasterRequestSchema;
    output: typeof GetPlantMasterResponseSchema;
  },
  /**
   * CreatePlantMaster creates a new plant master record and returns the full
   * detail of the created record. organization_id and created_by are
   * resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreatePlantMaster
   */
  createPlantMaster: {
    methodKind: "unary";
    input: typeof CreatePlantMasterRequestSchema;
    output: typeof CreatePlantMasterResponseSchema;
  },
  /**
   * UpdatePlantMaster performs a full replacement (PUT semantics) of the
   * plant master record. plant_code is immutable after creation (AC-006)
   * and is therefore excluded. Uses optimistic locking via expected_updated_at.
   * organization_id and updated_by are resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdatePlantMaster
   */
  updatePlantMaster: {
    methodKind: "unary";
    input: typeof UpdatePlantMasterRequestSchema;
    output: typeof UpdatePlantMasterResponseSchema;
  },
  /**
   * DeletePlantMaster deletes the plant master record. Uses optimistic locking
   * via expected_updated_at. organization_id is resolved by the BFF handler
   * from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeletePlantMaster
   */
  deletePlantMaster: {
    methodKind: "unary";
    input: typeof DeletePlantMasterRequestSchema;
    output: typeof DeletePlantMasterResponseSchema;
  },
  /**
   * ListGenerationSites returns every 発電所 (サイト) of the organization.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.ListGenerationSites
   */
  listGenerationSites: {
    methodKind: "unary";
    input: typeof ListGenerationSitesRequestSchema;
    output: typeof ListGenerationSitesResponseSchema;
  },
  /**
   * GetGenerationSite returns one 発電所 (サイト).
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetGenerationSite
   */
  getGenerationSite: {
    methodKind: "unary";
    input: typeof GetGenerationSiteRequestSchema;
    output: typeof GetGenerationSiteResponseSchema;
  },
  /**
   * CreateGenerationSite registers a 発電所 (サイト). AlreadyExists when the
   * name is already registered. organization_id and created_by are resolved
   * by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreateGenerationSite
   */
  createGenerationSite: {
    methodKind: "unary";
    input: typeof CreateGenerationSiteRequestSchema;
    output: typeof CreateGenerationSiteResponseSchema;
  },
  /**
   * UpdateGenerationSite overwrites a 発電所 (サイト). Uses optimistic locking
   * via expected_updated_at. organization_id and updated_by are resolved by
   * the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdateGenerationSite
   */
  updateGenerationSite: {
    methodKind: "unary";
    input: typeof UpdateGenerationSiteRequestSchema;
    output: typeof UpdateGenerationSiteResponseSchema;
  },
  /**
   * DeleteGenerationSite deletes a 発電所 (サイト). Uses optimistic locking via
   * expected_updated_at.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeleteGenerationSite
   */
  deleteGenerationSite: {
    methodKind: "unary";
    input: typeof DeleteGenerationSiteRequestSchema;
    output: typeof DeleteGenerationSiteResponseSchema;
  },
  /**
   * ListPlantUnits returns every 電源ユニット of the organization, each with its
   * derived area and 系統コード BG memberships.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.ListPlantUnits
   */
  listPlantUnits: {
    methodKind: "unary";
    input: typeof ListPlantUnitsRequestSchema;
    output: typeof ListPlantUnitsResponseSchema;
  },
  /**
   * GetPlantUnit returns one 電源ユニット.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetPlantUnit
   */
  getPlantUnit: {
    methodKind: "unary";
    input: typeof GetPlantUnitRequestSchema;
    output: typeof GetPlantUnitResponseSchema;
  },
  /**
   * CreatePlantUnit registers a 電源ユニット (and, when new_site is given, its
   * 発電所 in the same transaction). AlreadyExists when the unit name is already
   * used in the 発電所 (or the new 発電所's name is already registered).
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreatePlantUnit
   */
  createPlantUnit: {
    methodKind: "unary";
    input: typeof CreatePlantUnitRequestSchema;
    output: typeof CreatePlantUnitResponseSchema;
  },
  /**
   * UpdatePlantUnit overwrites a 電源ユニット. Uses optimistic locking via
   * expected_updated_at. AlreadyExists on a unit-name collision in the 発電所.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdatePlantUnit
   */
  updatePlantUnit: {
    methodKind: "unary";
    input: typeof UpdatePlantUnitRequestSchema;
    output: typeof UpdatePlantUnitResponseSchema;
  },
  /**
   * DeletePlantUnit deletes a 電源ユニット. Uses optimistic locking via
   * expected_updated_at. FailedPrecondition (reason PLANT_UNIT_ERROR_REASON_MANAGED)
   * when its 系統コード is under management by an own 発電 BG in any period.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeletePlantUnit
   */
  deletePlantUnit: {
    methodKind: "unary";
    input: typeof DeletePlantUnitRequestSchema;
    output: typeof DeletePlantUnitResponseSchema;
  },
  /**
   * ListSplitSupplyContracts returns the 分割供給契約 list-screen projection.
   * organization_id is resolved from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.ListSplitSupplyContracts
   */
  listSplitSupplyContracts: {
    methodKind: "unary";
    input: typeof ListSplitSupplyContractsRequestSchema;
    output: typeof ListSplitSupplyContractsResponseSchema;
  },
  /**
   * GetSplitSupplyContract returns one contract with its 基本パターン.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetSplitSupplyContract
   */
  getSplitSupplyContract: {
    methodKind: "unary";
    input: typeof GetSplitSupplyContractRequestSchema;
    output: typeof GetSplitSupplyContractResponseSchema;
  },
  /**
   * CreateSplitSupplyContract creates a contract and its 基本パターン.
   * organization_id and created_by are resolved by the BFF handler from eauth.
   * A rejected request carries a SplitSupplyContractErrorReason.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.CreateSplitSupplyContract
   */
  createSplitSupplyContract: {
    methodKind: "unary";
    input: typeof CreateSplitSupplyContractRequestSchema;
    output: typeof CreateSplitSupplyContractResponseSchema;
  },
  /**
   * UpdateSplitSupplyContract replaces the editable fields and all 基本パターン.
   * Uses optimistic locking via expected_updated_at. organization_id and
   * updated_by are resolved by the BFF handler from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.UpdateSplitSupplyContract
   */
  updateSplitSupplyContract: {
    methodKind: "unary";
    input: typeof UpdateSplitSupplyContractRequestSchema;
    output: typeof UpdateSplitSupplyContractResponseSchema;
  },
  /**
   * DeleteSplitSupplyContract deletes the contract and its 基本パターン. Uses
   * optimistic locking via expected_updated_at.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.DeleteSplitSupplyContract
   */
  deleteSplitSupplyContract: {
    methodKind: "unary";
    input: typeof DeleteSplitSupplyContractRequestSchema;
    output: typeof DeleteSplitSupplyContractResponseSchema;
  },
  /**
   * GetSplitSupplyContractFormOptions returns the candidates of the
   * registration form. organization_id is resolved from eauth.
   *
   * @generated from rpc bffuser.v1.OcctoMasterService.GetSplitSupplyContractFormOptions
   */
  getSplitSupplyContractFormOptions: {
    methodKind: "unary";
    input: typeof GetSplitSupplyContractFormOptionsRequestSchema;
    output: typeof GetSplitSupplyContractFormOptionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_occto_master_service, 0);

